// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.18 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-yellow-100: oklch(97.3% 0.071 103.193);
    --color-yellow-700: oklch(55.4% 0.135 66.442);
    --color-yellow-800: oklch(47.6% 0.114 61.907);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-blue-800: oklch(42.4% 0.199 265.638);
    --color-indigo-100: oklch(93% 0.034 272.788);
    --color-indigo-700: oklch(45.7% 0.24 277.023);
    --color-indigo-800: oklch(39.8% 0.195 277.366);
    --color-stone-50: oklch(98.5% 0.001 106.423);
    --color-stone-100: oklch(97% 0.001 106.424);
    --color-stone-200: oklch(92.3% 0.003 48.717);
    --color-stone-300: oklch(86.9% 0.005 56.366);
    --color-stone-400: oklch(70.9% 0.01 56.259);
    --color-stone-500: oklch(55.3% 0.013 58.071);
    --color-stone-600: oklch(44.4% 0.011 73.639);
    --color-stone-700: oklch(37.4% 0.01 67.558);
    --color-stone-800: oklch(26.8% 0.007 34.298);
    --color-stone-900: oklch(21.6% 0.006 56.043);
    --color-stone-950: oklch(14.7% 0.004 49.25);
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --text-7xl: 4.5rem;
    --text-7xl--line-height: 1;
    --text-8xl: 6rem;
    --text-8xl--line-height: 1;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --leading-relaxed: 1.625;
    --radius-md: 0.375rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --animate-bounce: bounce 1s infinite;
    --blur-sm: 8px;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-display: "Fraunces", "Cormorant Garamond", Georgia, serif;
    --font-heading: "Inter", ui-sans-serif, system-ui, sans-serif;
    --color-accent: var(--color-clay-500);
    --color-surface: var(--color-bone-50);
    --color-surface-alt: var(--color-bone-100);
    --color-surface-inverse: var(--color-obsidian-900);
    --color-text-primary: var(--color-obsidian-800);
    --color-text-heading: var(--color-obsidian-900);
    --color-text-secondary: var(--color-dune-600);
    --color-text-inverse: var(--color-bone-50);
    --color-border-default: var(--color-dune-200);
    --color-border-strong: var(--color-obsidian-900);
    --color-btn-primary-bg: var(--color-obsidian-900);
    --color-btn-primary-text: var(--color-bone-50);
    --color-btn-primary-border: var(--color-obsidian-900);
    --color-btn-primary-hover-bg: var(--color-clay-500);
    --color-btn-primary-hover-border: var(--color-clay-500);
    --radius-theme: 0px;
    --color-obsidian-400: #8e7454;
    --color-obsidian-500: #6a543c;
    --color-obsidian-600: #4c3c2b;
    --color-obsidian-700: #352a1e;
    --color-obsidian-800: #221a13;
    --color-obsidian-900: #14100b;
    --color-obsidian-950: #0a0705;
    --color-bone-50: #fbf7ef;
    --color-bone-100: #f6efdf;
    --color-bone-200: #efe0c4;
    --color-dune-100: #e9dcc2;
    --color-dune-200: #d6c39f;
    --color-dune-300: #bfa477;
    --color-dune-400: #a3855a;
    --color-dune-600: #635038;
    --color-clay-50: #faf0e8;
    --color-clay-300: #d2945e;
    --color-clay-400: #bc7337;
    --color-clay-500: #a2581f;
    --color-clay-600: #854319;
    --color-clay-700: #673214;
    --color-ember-200: #f4c775;
    --color-ember-300: #eca23d;
    --color-ember-400: #dc8420;
    --color-ember-500: #b66718;
    --color-sage-300: #95a077;
    --color-sage-500: #535f3f;
    --color-indigo-jp-50: #f6f7f9;
    --color-indigo-jp-200: #d2dae5;
    --color-indigo-jp-700: #2d4562;
    --color-indigo-jp-800: #1e3a5f;
    --color-shu-50: #fef5f5;
    --color-shu-200: #fbd5d5;
    --color-shu-500: #e85c60;
    --color-shu-600: #c53d43;
    --color-shu-700: #a73135;
    --color-washi-100: #faf8f5;
    --color-matcha-50: #f5f7f4;
    --color-matcha-200: #d1dace;
    --color-matcha-500: #7d8c6e;
    --color-matcha-600: #5f7054;
    --color-matcha-700: #4c5a44;
    --color-sumi-50: #f8f8f7;
    --color-sumi-100: #eeeeec;
    --color-sumi-200: #d9d9d6;
    --color-sumi-300: #b8b8b3;
    --color-sumi-500: #6b6b64;
    --color-sumi-600: #4d4d47;
    --color-sumi-900: #1a1a17;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .-top-0\\.5 {
    top: calc(var(--spacing) * -0.5);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1 {
    top: calc(var(--spacing) * 1);
  }
  .top-1\\/2 {
    top: calc(1/2 * 100%);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .-right-0\\.5 {
    right: calc(var(--spacing) * -0.5);
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-1 {
    right: calc(var(--spacing) * 1);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-1 {
    bottom: calc(var(--spacing) * 1);
  }
  .bottom-8 {
    bottom: calc(var(--spacing) * 8);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-1\\/2 {
    left: calc(1/2 * 100%);
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .left-6 {
    left: calc(var(--spacing) * 6);
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-span-6 {
    grid-column: span 6 / span 6;
  }
  .col-span-10 {
    grid-column: span 10 / span 10;
  }
  .col-span-12 {
    grid-column: span 12 / span 12;
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-6 {
    margin-block: calc(var(--spacing) * 6);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-7 {
    margin-top: calc(var(--spacing) * 7);
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8);
  }
  .mt-10 {
    margin-top: calc(var(--spacing) * 10);
  }
  .mt-12 {
    margin-top: calc(var(--spacing) * 12);
  }
  .mt-14 {
    margin-top: calc(var(--spacing) * 14);
  }
  .mt-24 {
    margin-top: calc(var(--spacing) * 24);
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .mb-14 {
    margin-bottom: calc(var(--spacing) * 14);
  }
  .ml-auto {
    margin-left: auto;
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-\\[4\\/5\\] {
    aspect-ratio: 4/5;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-4\\.5 {
    height: calc(var(--spacing) * 4.5);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-\\[60vh\\] {
    height: 60vh;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .h-screen {
    height: 100vh;
  }
  .min-h-\\[60vh\\] {
    min-height: 60vh;
  }
  .min-h-\\[70vh\\] {
    min-height: 70vh;
  }
  .min-h-\\[80px\\] {
    min-height: 80px;
  }
  .min-h-\\[85vh\\] {
    min-height: 85vh;
  }
  .min-h-\\[120px\\] {
    min-height: 120px;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-1\\/3 {
    width: calc(1/3 * 100%);
  }
  .w-1\\/4 {
    width: calc(1/4 * 100%);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\/3 {
    width: calc(2/3 * 100%);
  }
  .w-3\\/4 {
    width: calc(3/4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-4\\.5 {
    width: calc(var(--spacing) * 4.5);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-7xl {
    max-width: var(--container-7xl);
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0 {
    --tw-translate-x: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1/2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0 {
    --tw-translate-y: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-full {
    --tw-translate-y: 100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-150 {
    --tw-scale-x: 150%;
    --tw-scale-y: 150%;
    --tw-scale-z: 150%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-bounce {
    animation: var(--animate-bounce);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .list-inside {
    list-style-position: inside;
  }
  .list-disc {
    list-style-type: disc;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-12 {
    gap: calc(var(--spacing) * 12);
  }
  .space-y-0 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8);
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-stone-100 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-stone-100);
    }
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-2 {
    border-top-style: var(--tw-border-style);
    border-top-width: 2px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-clay-500\\/60 {
    border-color: color-mix(in srgb, #a2581f 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-clay-500) 60%, transparent);
    }
  }
  .border-dune-200\\/60 {
    border-color: color-mix(in srgb, #d6c39f 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-dune-200) 60%, transparent);
    }
  }
  .border-dune-300 {
    border-color: var(--color-dune-300);
  }
  .border-green-200 {
    border-color: var(--color-green-200);
  }
  .border-green-600 {
    border-color: var(--color-green-600);
  }
  .border-obsidian-700 {
    border-color: var(--color-obsidian-700);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-red-600 {
    border-color: var(--color-red-600);
  }
  .border-shu-200 {
    border-color: var(--color-shu-200);
  }
  .border-stone-100 {
    border-color: var(--color-stone-100);
  }
  .border-stone-200 {
    border-color: var(--color-stone-200);
  }
  .border-stone-900 {
    border-color: var(--color-stone-900);
  }
  .border-sumi-200 {
    border-color: var(--color-sumi-200);
  }
  .border-transparent {
    border-color: transparent;
  }
  .bg-blue-100 {
    background-color: var(--color-blue-100);
  }
  .bg-bone-50 {
    background-color: var(--color-bone-50);
  }
  .bg-bone-50\\/85 {
    background-color: color-mix(in srgb, #fbf7ef 85%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-bone-50) 85%, transparent);
    }
  }
  .bg-bone-100 {
    background-color: var(--color-bone-100);
  }
  .bg-clay-400 {
    background-color: var(--color-clay-400);
  }
  .bg-clay-500 {
    background-color: var(--color-clay-500);
  }
  .bg-clay-500\\/40 {
    background-color: color-mix(in srgb, #a2581f 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-clay-500) 40%, transparent);
    }
  }
  .bg-dune-100 {
    background-color: var(--color-dune-100);
  }
  .bg-dune-200\\/40 {
    background-color: color-mix(in srgb, #d6c39f 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-dune-200) 40%, transparent);
    }
  }
  .bg-dune-200\\/50 {
    background-color: color-mix(in srgb, #d6c39f 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-dune-200) 50%, transparent);
    }
  }
  .bg-dune-200\\/60 {
    background-color: color-mix(in srgb, #d6c39f 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-dune-200) 60%, transparent);
    }
  }
  .bg-dune-300 {
    background-color: var(--color-dune-300);
  }
  .bg-ember-400 {
    background-color: var(--color-ember-400);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-100 {
    background-color: var(--color-green-100);
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-green-700 {
    background-color: var(--color-green-700);
  }
  .bg-indigo-100 {
    background-color: var(--color-indigo-100);
  }
  .bg-indigo-700 {
    background-color: var(--color-indigo-700);
  }
  .bg-indigo-jp-800 {
    background-color: var(--color-indigo-jp-800);
  }
  .bg-obsidian-900 {
    background-color: var(--color-obsidian-900);
  }
  .bg-obsidian-900\\/40 {
    background-color: color-mix(in srgb, #14100b 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-obsidian-900) 40%, transparent);
    }
  }
  .bg-obsidian-900\\/60 {
    background-color: color-mix(in srgb, #14100b 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-obsidian-900) 60%, transparent);
    }
  }
  .bg-obsidian-900\\/85 {
    background-color: color-mix(in srgb, #14100b 85%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-obsidian-900) 85%, transparent);
    }
  }
  .bg-obsidian-950 {
    background-color: var(--color-obsidian-950);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-600 {
    background-color: var(--color-red-600);
  }
  .bg-shu-50 {
    background-color: var(--color-shu-50);
  }
  .bg-stone-50 {
    background-color: var(--color-stone-50);
  }
  .bg-stone-100 {
    background-color: var(--color-stone-100);
  }
  .bg-stone-200 {
    background-color: var(--color-stone-200);
  }
  .bg-stone-800 {
    background-color: var(--color-stone-800);
  }
  .bg-stone-900 {
    background-color: var(--color-stone-900);
  }
  .bg-stone-950 {
    background-color: var(--color-stone-950);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-washi-100 {
    background-color: var(--color-washi-100);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/90 {
    background-color: color-mix(in srgb, #fff 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 90%, transparent);
    }
  }
  .bg-yellow-100 {
    background-color: var(--color-yellow-100);
  }
  .object-cover {
    object-fit: cover;
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-16 {
    padding-block: calc(var(--spacing) * 16);
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20);
  }
  .py-24 {
    padding-block: calc(var(--spacing) * 24);
  }
  .py-28 {
    padding-block: calc(var(--spacing) * 28);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-20 {
    padding-top: calc(var(--spacing) * 20);
  }
  .pt-24 {
    padding-top: calc(var(--spacing) * 24);
  }
  .pr-5 {
    padding-right: calc(var(--spacing) * 5);
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-12 {
    padding-bottom: calc(var(--spacing) * 12);
  }
  .pb-20 {
    padding-bottom: calc(var(--spacing) * 20);
  }
  .pl-6 {
    padding-left: calc(var(--spacing) * 6);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .font-display {
    font-family: var(--font-display);
  }
  .font-heading {
    font-family: var(--font-heading);
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-6xl {
    font-size: var(--text-6xl);
    line-height: var(--tw-leading, var(--text-6xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .leading-\\[0\\.9\\] {
    --tw-leading: 0.9;
    line-height: 0.9;
  }
  .leading-\\[0\\.88\\] {
    --tw-leading: 0.88;
    line-height: 0.88;
  }
  .leading-\\[0\\.95\\] {
    --tw-leading: 0.95;
    line-height: 0.95;
  }
  .leading-\\[1\\.05\\] {
    --tw-leading: 1.05;
    line-height: 1.05;
  }
  .leading-\\[1\\.6\\] {
    --tw-leading: 1.6;
    line-height: 1.6;
  }
  .leading-\\[1\\.15\\] {
    --tw-leading: 1.15;
    line-height: 1.15;
  }
  .leading-\\[1\\.55\\] {
    --tw-leading: 1.55;
    line-height: 1.55;
  }
  .leading-\\[1\\.65\\] {
    --tw-leading: 1.65;
    line-height: 1.65;
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[-0\\.02em\\] {
    --tw-tracking: -0.02em;
    letter-spacing: -0.02em;
  }
  .tracking-\\[0\\.2em\\] {
    --tw-tracking: 0.2em;
    letter-spacing: 0.2em;
  }
  .tracking-\\[0\\.3em\\] {
    --tw-tracking: 0.3em;
    letter-spacing: 0.3em;
  }
  .tracking-\\[0\\.15em\\] {
    --tw-tracking: 0.15em;
    letter-spacing: 0.15em;
  }
  .tracking-\\[0\\.18em\\] {
    --tw-tracking: 0.18em;
    letter-spacing: 0.18em;
  }
  .tracking-\\[0\\.24em\\] {
    --tw-tracking: 0.24em;
    letter-spacing: 0.24em;
  }
  .tracking-\\[0\\.28em\\] {
    --tw-tracking: 0.28em;
    letter-spacing: 0.28em;
  }
  .tracking-\\[0\\.32em\\] {
    --tw-tracking: 0.32em;
    letter-spacing: 0.32em;
  }
  .tracking-\\[0\\.35em\\] {
    --tw-tracking: 0.35em;
    letter-spacing: 0.35em;
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .text-blue-700 {
    color: var(--color-blue-700);
  }
  .text-blue-800 {
    color: var(--color-blue-800);
  }
  .text-bone-50 {
    color: var(--color-bone-50);
  }
  .text-bone-100 {
    color: var(--color-bone-100);
  }
  .text-bone-200 {
    color: var(--color-bone-200);
  }
  .text-bone-200\\/70 {
    color: color-mix(in srgb, #efe0c4 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-bone-200) 70%, transparent);
    }
  }
  .text-bone-200\\/80 {
    color: color-mix(in srgb, #efe0c4 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-bone-200) 80%, transparent);
    }
  }
  .text-clay-300 {
    color: var(--color-clay-300);
  }
  .text-clay-500 {
    color: var(--color-clay-500);
  }
  .text-clay-600 {
    color: var(--color-clay-600);
  }
  .text-dune-300 {
    color: var(--color-dune-300);
  }
  .text-dune-400 {
    color: var(--color-dune-400);
  }
  .text-ember-200 {
    color: var(--color-ember-200);
  }
  .text-ember-300 {
    color: var(--color-ember-300);
  }
  .text-ember-300\\/80 {
    color: color-mix(in srgb, #eca23d 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-ember-300) 80%, transparent);
    }
  }
  .text-ember-300\\/90 {
    color: color-mix(in srgb, #eca23d 90%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-ember-300) 90%, transparent);
    }
  }
  .text-ember-400 {
    color: var(--color-ember-400);
  }
  .text-ember-500 {
    color: var(--color-ember-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-indigo-800 {
    color: var(--color-indigo-800);
  }
  .text-obsidian-400 {
    color: var(--color-obsidian-400);
  }
  .text-obsidian-500 {
    color: var(--color-obsidian-500);
  }
  .text-obsidian-600 {
    color: var(--color-obsidian-600);
  }
  .text-obsidian-700 {
    color: var(--color-obsidian-700);
  }
  .text-obsidian-900 {
    color: var(--color-obsidian-900);
  }
  .text-red-400 {
    color: var(--color-red-400);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-red-800 {
    color: var(--color-red-800);
  }
  .text-sage-300 {
    color: var(--color-sage-300);
  }
  .text-sage-500 {
    color: var(--color-sage-500);
  }
  .text-shu-700 {
    color: var(--color-shu-700);
  }
  .text-stone-300 {
    color: var(--color-stone-300);
  }
  .text-stone-400 {
    color: var(--color-stone-400);
  }
  .text-stone-500 {
    color: var(--color-stone-500);
  }
  .text-stone-600 {
    color: var(--color-stone-600);
  }
  .text-stone-700 {
    color: var(--color-stone-700);
  }
  .text-stone-900 {
    color: var(--color-stone-900);
  }
  .text-sumi-600 {
    color: var(--color-sumi-600);
  }
  .text-sumi-900 {
    color: var(--color-sumi-900);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-yellow-700 {
    color: var(--color-yellow-700);
  }
  .text-yellow-800 {
    color: var(--color-yellow-800);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-4 {
    text-underline-offset: 4px;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-90 {
    opacity: 90%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .duration-700 {
    --tw-duration: 700ms;
    transition-duration: 700ms;
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .group-hover\\:translate-x-1 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-translate-x: calc(var(--spacing) * 1);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
  .group-hover\\:scale-105 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 105%;
        --tw-scale-y: 105%;
        --tw-scale-z: 105%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\:text-clay-600 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-clay-600);
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .placeholder\\:text-bone-200\\/40 {
    &::placeholder {
      color: color-mix(in srgb, #efe0c4 40%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-bone-200) 40%, transparent);
      }
    }
  }
  .placeholder\\:text-obsidian-400 {
    &::placeholder {
      color: var(--color-obsidian-400);
    }
  }
  .last\\:border-0 {
    &:last-child {
      border-style: var(--tw-border-style);
      border-width: 0px;
    }
  }
  .last\\:pb-0 {
    &:last-child {
      padding-bottom: calc(var(--spacing) * 0);
    }
  }
  .hover\\:border-stone-300 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-stone-300);
      }
    }
  }
  .hover\\:border-stone-400 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-stone-400);
      }
    }
  }
  .hover\\:border-stone-700 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-stone-700);
      }
    }
  }
  .hover\\:border-stone-900 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-stone-900);
      }
    }
  }
  .hover\\:bg-clay-400 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-clay-400);
      }
    }
  }
  .hover\\:bg-clay-600 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-clay-600);
      }
    }
  }
  .hover\\:bg-green-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green-800);
      }
    }
  }
  .hover\\:bg-indigo-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-indigo-800);
      }
    }
  }
  .hover\\:bg-red-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-50);
      }
    }
  }
  .hover\\:bg-stone-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-stone-50);
      }
    }
  }
  .hover\\:bg-stone-300 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-stone-300);
      }
    }
  }
  .hover\\:bg-stone-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-stone-700);
      }
    }
  }
  .hover\\:bg-stone-800\\/50 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(26.8% 0.007 34.298) 50%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-stone-800) 50%, transparent);
        }
      }
    }
  }
  .hover\\:bg-stone-900 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-stone-900);
      }
    }
  }
  .hover\\:bg-sumi-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-sumi-50);
      }
    }
  }
  .hover\\:text-bone-50 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-bone-50);
      }
    }
  }
  .hover\\:text-clay-300 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-clay-300);
      }
    }
  }
  .hover\\:text-clay-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-clay-600);
      }
    }
  }
  .hover\\:text-clay-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-clay-700);
      }
    }
  }
  .hover\\:text-obsidian-900 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-obsidian-900);
      }
    }
  }
  .hover\\:text-red-800 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-800);
      }
    }
  }
  .hover\\:text-stone-900 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-stone-900);
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .focus\\:border-clay-400 {
    &:focus {
      border-color: var(--color-clay-400);
    }
  }
  .focus\\:border-clay-500 {
    &:focus {
      border-color: var(--color-clay-500);
    }
  }
  .focus\\:border-stone-900 {
    &:focus {
      border-color: var(--color-stone-900);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60%;
    }
  }
  .sm\\:col-span-2 {
    @media (width >= 40rem) {
      grid-column: span 2 / span 2;
    }
  }
  .sm\\:block {
    @media (width >= 40rem) {
      display: block;
    }
  }
  .sm\\:flex {
    @media (width >= 40rem) {
      display: flex;
    }
  }
  .sm\\:hidden {
    @media (width >= 40rem) {
      display: none;
    }
  }
  .sm\\:inline-flex {
    @media (width >= 40rem) {
      display: inline-flex;
    }
  }
  .sm\\:h-28 {
    @media (width >= 40rem) {
      height: calc(var(--spacing) * 28);
    }
  }
  .sm\\:w-24 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 24);
    }
  }
  .sm\\:w-56 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 56);
    }
  }
  .sm\\:w-80 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 80);
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-3 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .sm\\:grid-cols-4 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:gap-4 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 4);
    }
  }
  .sm\\:gap-6 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-6 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 6);
    }
  }
  .sm\\:px-10 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 10);
    }
  }
  .sm\\:text-4xl {
    @media (width >= 40rem) {
      font-size: var(--text-4xl);
      line-height: var(--tw-leading, var(--text-4xl--line-height));
    }
  }
  .sm\\:text-5xl {
    @media (width >= 40rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .sm\\:text-6xl {
    @media (width >= 40rem) {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
  }
  .sm\\:text-7xl {
    @media (width >= 40rem) {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:col-span-1 {
    @media (width >= 64rem) {
      grid-column: span 1 / span 1;
    }
  }
  .lg\\:col-span-2 {
    @media (width >= 64rem) {
      grid-column: span 2 / span 2;
    }
  }
  .lg\\:col-span-3 {
    @media (width >= 64rem) {
      grid-column: span 3 / span 3;
    }
  }
  .lg\\:col-span-4 {
    @media (width >= 64rem) {
      grid-column: span 4 / span 4;
    }
  }
  .lg\\:col-span-5 {
    @media (width >= 64rem) {
      grid-column: span 5 / span 5;
    }
  }
  .lg\\:col-span-6 {
    @media (width >= 64rem) {
      grid-column: span 6 / span 6;
    }
  }
  .lg\\:col-span-7 {
    @media (width >= 64rem) {
      grid-column: span 7 / span 7;
    }
  }
  .lg\\:block {
    @media (width >= 64rem) {
      display: block;
    }
  }
  .lg\\:flex {
    @media (width >= 64rem) {
      display: flex;
    }
  }
  .lg\\:hidden {
    @media (width >= 64rem) {
      display: none;
    }
  }
  .lg\\:min-h-screen {
    @media (width >= 64rem) {
      min-height: 100vh;
    }
  }
  .lg\\:w-1\\/2 {
    @media (width >= 64rem) {
      width: calc(1/2 * 100%);
    }
  }
  .lg\\:max-w-\\[50\\%\\] {
    @media (width >= 64rem) {
      max-width: 50%;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-12 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }
  }
  .lg\\:gap-8 {
    @media (width >= 64rem) {
      gap: calc(var(--spacing) * 8);
    }
  }
  .lg\\:gap-20 {
    @media (width >= 64rem) {
      gap: calc(var(--spacing) * 20);
    }
  }
  .lg\\:px-8 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 8);
    }
  }
  .lg\\:px-16 {
    @media (width >= 64rem) {
      padding-inline: calc(var(--spacing) * 16);
    }
  }
  .lg\\:py-12 {
    @media (width >= 64rem) {
      padding-block: calc(var(--spacing) * 12);
    }
  }
  .lg\\:py-28 {
    @media (width >= 64rem) {
      padding-block: calc(var(--spacing) * 28);
    }
  }
  .lg\\:py-32 {
    @media (width >= 64rem) {
      padding-block: calc(var(--spacing) * 32);
    }
  }
  .lg\\:pt-28 {
    @media (width >= 64rem) {
      padding-top: calc(var(--spacing) * 28);
    }
  }
  .lg\\:pt-36 {
    @media (width >= 64rem) {
      padding-top: calc(var(--spacing) * 36);
    }
  }
  .lg\\:pr-8 {
    @media (width >= 64rem) {
      padding-right: calc(var(--spacing) * 8);
    }
  }
  .lg\\:pb-16 {
    @media (width >= 64rem) {
      padding-bottom: calc(var(--spacing) * 16);
    }
  }
  .lg\\:pb-28 {
    @media (width >= 64rem) {
      padding-bottom: calc(var(--spacing) * 28);
    }
  }
  .lg\\:pb-32 {
    @media (width >= 64rem) {
      padding-bottom: calc(var(--spacing) * 32);
    }
  }
  .lg\\:text-right {
    @media (width >= 64rem) {
      text-align: right;
    }
  }
  .lg\\:text-2xl {
    @media (width >= 64rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .lg\\:text-3xl {
    @media (width >= 64rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .lg\\:text-5xl {
    @media (width >= 64rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .lg\\:text-6xl {
    @media (width >= 64rem) {
      font-size: var(--text-6xl);
      line-height: var(--tw-leading, var(--text-6xl--line-height));
    }
  }
  .lg\\:text-7xl {
    @media (width >= 64rem) {
      font-size: var(--text-7xl);
      line-height: var(--tw-leading, var(--text-7xl--line-height));
    }
  }
  .lg\\:text-8xl {
    @media (width >= 64rem) {
      font-size: var(--text-8xl);
      line-height: var(--tw-leading, var(--text-8xl--line-height));
    }
  }
  .lg\\:text-lg {
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
}
[data-theme="minimal"] {
  --font-display: "Poppins", ui-sans-serif, system-ui, sans-serif;
  --font-heading: "Poppins", ui-sans-serif, system-ui, sans-serif;
  --font-editorial: "Poppins", ui-sans-serif, system-ui, sans-serif;
  --font-body: "Nunito", ui-sans-serif, system-ui, sans-serif;
  --color-accent: #6366f1;
  --color-accent-hover: #4f46e5;
  --color-accent-light: #eef2ff;
  --color-surface: #ffffff;
  --color-surface-alt: #f8fafc;
  --color-surface-inverse: #1e1b4b;
  --color-text-primary: #475569;
  --color-text-heading: #1e293b;
  --color-text-secondary: #94a3b8;
  --color-text-inverse: #ffffff;
  --color-border-default: #e2e8f0;
  --color-border-strong: #1e293b;
  --color-btn-primary-bg: #6366f1;
  --color-btn-primary-text: #ffffff;
  --color-btn-primary-border: #6366f1;
  --color-btn-primary-hover-bg: #4f46e5;
  --color-btn-primary-hover-border: #4f46e5;
  --radius-theme: 12px;
  --radius-theme-lg: 16px;
}
[data-theme="minimal"] .jp-btn-primary {
  border-radius: 9999px;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: none;
  letter-spacing: 0.01em;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-color: transparent;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  transition: all 0.2s ease;
}
[data-theme="minimal"] .jp-btn-primary:hover {
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  transform: translateY(-1px);
}
[data-theme="minimal"] .jp-btn-secondary,
[data-theme="minimal"] .jp-btn-ghost {
  border-radius: 9999px;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: none;
  letter-spacing: 0.01em;
}
[data-theme="minimal"] .jp-card {
  border-radius: var(--radius-theme);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06),
    0 4px 12px rgba(0, 0, 0, 0.04);
  border-color: transparent;
  transition: all 0.25s ease;
}
[data-theme="minimal"] .jp-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08),
    0 8px 32px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}
[data-theme="minimal"] .jp-input,
[data-theme="minimal"] .jp-select {
  border-radius: var(--radius-theme);
  border-color: var(--color-border-default);
  padding: 0.75rem 1rem;
  transition: border-color 0.2s,
    box-shadow 0.2s;
}
[data-theme="minimal"] .jp-input:focus,
[data-theme="minimal"] .jp-select:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}
[data-theme="minimal"] .jp-label {
  text-transform: none;
  letter-spacing: 0.01em;
  font-weight: 600;
  font-size: 0.8125rem;
  color: var(--color-text-heading);
}
[data-theme="minimal"] .site-nav {
  border-bottom: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
[data-theme="minimal"] .announcement-bar {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 600;
  font-size: 0.75rem;
  border-radius: 0;
}
[data-theme="minimal"] .hero-section {
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 40%, #4338ca 100%) !important;
  border-radius: 0 0 2rem 2rem;
  overflow: hidden;
}
[data-theme="minimal"] .hero-section .hero-grid {
  min-height: 480px !important;
}
@media (min-width: 1024px) {
  [data-theme="minimal"] .hero-section .hero-grid {
    min-height: 560px !important;
  }
}
[data-theme="minimal"] .hero-section .hero-grid > div:last-child {
  padding: 1.5rem 1.5rem 1.5rem 0;
}
[data-theme="minimal"] .hero-section .hero-grid > div:last-child img {
  border-radius: 1.5rem;
}
[data-theme="minimal"] .hero-section .accent-line {
  border-radius: 9999px;
  height: 4px;
  width: 3rem;
}
[data-theme="minimal"] .hero-section .section-header-label {
  background-color: rgba(255, 255, 255, 0.12);
  display: inline-block;
  padding: 0.375rem 1rem;
  border-radius: 9999px;
  text-transform: none;
  letter-spacing: 0.04em;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1rem;
}
[data-theme="minimal"] .hero-section .hero-text h1 {
  text-transform: none;
  letter-spacing: -0.02em;
  line-height: 1.1;
  font-weight: 700;
}
[data-theme="minimal"] .hero-section .hero-text p {
  color: rgba(255, 255, 255, 0.65);
  font-family: "Nunito", ui-sans-serif, sans-serif;
}
[data-theme="minimal"] .hero-section .hero-cta-primary {
  background: linear-gradient(135deg, #f59e0b, #f97316) !important;
  border: none;
  border-radius: 9999px;
  padding: 1rem 2.5rem;
  font-weight: 700;
  font-size: 0.9375rem;
  text-transform: none;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.4);
  transition: all 0.2s ease;
}
[data-theme="minimal"] .hero-section .hero-cta-primary:hover {
  box-shadow: 0 6px 24px rgba(249, 115, 22, 0.5);
  transform: translateY(-1px);
}
[data-theme="minimal"] .hero-section .hero-cta-secondary {
  border-radius: 9999px;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 0.3);
  padding: 1rem 2.5rem;
  font-weight: 600;
  font-size: 0.9375rem;
  text-transform: none;
  letter-spacing: 0.02em;
}
[data-theme="minimal"] .hero-section .hero-cta-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
}
[data-theme="minimal"] .section-header-label {
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 600;
  font-size: 0.8125rem;
  color: var(--color-accent);
}
[data-theme="minimal"] .section-header-title {
  text-transform: none;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-size: 2rem;
}
@media (min-width: 640px) {
  [data-theme="minimal"] .section-header-title {
    font-size: 2.5rem;
  }
}
[data-theme="minimal"] .section-featured {
  background-color: var(--color-surface-alt);
  padding-top: 4rem;
  padding-bottom: 4rem;
}
[data-theme="minimal"] .section-featured .featured-grid {
  gap: 1.5rem;
}
[data-theme="minimal"] .promo-badges {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
[data-theme="minimal"] .promo-badges .promo-badge-card {
  border-radius: var(--radius-theme);
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05),
    0 4px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
}
[data-theme="minimal"] .promo-badges .promo-badge-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08),
    0 8px 24px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}
[data-theme="minimal"] .promo-badges .promo-badge-card img {
  border-radius: 10px;
}
[data-theme="minimal"] .section-promo-banner {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
[data-theme="minimal"] .section-promo-banner > div > div {
  border-radius: 1.5rem;
  overflow: hidden;
}
[data-theme="minimal"] .section-promo-banner .promo-dark-panel {
  background: linear-gradient(135deg, #1e1b4b, #312e81);
}
[data-theme="minimal"] .section-promo-banner .promo-dark-panel .accent-line {
  border-radius: 9999px;
  height: 4px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
}
[data-theme="minimal"] .section-promo-banner .section-header-label {
  color: #f59e0b;
}
[data-theme="minimal"] .section-promo-banner .section-header-title {
  color: white;
  text-transform: none;
  font-weight: 700;
}
[data-theme="minimal"] .section-promo-banner a[href="/shop"] {
  border-radius: 9999px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35);
}
[data-theme="minimal"] .section-explore {
  background-color: #ffffff;
}
[data-theme="minimal"] .section-explore .stat-value {
  font-weight: 800;
  color: var(--color-accent);
  font-size: 3rem;
}
[data-theme="minimal"] .section-explore .group.relative.overflow-hidden {
  border-radius: var(--radius-theme);
}
[data-theme="minimal"] .section-product-grid {
  background-color: var(--color-surface-alt);
  padding-top: 4rem;
  padding-bottom: 4rem;
}
[data-theme="minimal"] .section-product-grid .product-grid {
  gap: 1.5rem;
}
[data-theme="minimal"] .product-card {
  border-radius: var(--radius-theme);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06),
    0 4px 12px rgba(0, 0, 0, 0.04);
  border: none;
  transition: all 0.25s ease;
}
[data-theme="minimal"] .product-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1),
    0 16px 48px rgba(0, 0, 0, 0.06);
  transform: translateY(-4px);
}
[data-theme="minimal"] .product-card .quick-view-bar {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 600;
  border-radius: 0;
  padding: 0.75rem;
}
[data-theme="minimal"] .product-card .product-name {
  font-weight: 600;
  font-size: 0.9375rem;
  text-transform: none;
}
[data-theme="minimal"] .product-card .product-price {
  font-weight: 700;
  color: var(--color-accent);
  font-size: 0.9375rem;
}
[data-theme="minimal"] .section-mens {
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%) !important;
  border-radius: 0;
}
[data-theme="minimal"] .section-mens h2 {
  text-transform: none;
  font-weight: 700;
  letter-spacing: -0.02em;
}
[data-theme="minimal"] .section-mens .section-header-label {
  color: #f59e0b;
}
[data-theme="minimal"] .section-mens a[href="/shop/men"] {
  border-radius: 9999px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35);
}
[data-theme="minimal"] footer {
  background-color: var(--color-surface-alt) !important;
  border-top: 1px solid var(--color-border-default);
}
[data-theme="minimal"] footer .font-display {
  color: var(--color-text-heading);
}
[data-theme="minimal"] footer h3 {
  color: var(--color-text-heading);
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 700;
}
[data-theme="minimal"] footer a,
[data-theme="minimal"] footer li,
[data-theme="minimal"] footer p,
[data-theme="minimal"] footer span {
  color: var(--color-text-primary);
}
[data-theme="minimal"] footer a:hover {
  color: var(--color-accent);
}
[data-theme="minimal"] footer .border-t {
  border-color: var(--color-border-default);
}
[data-theme="minimal"] .shop-header h1 {
  text-transform: none;
  font-weight: 700;
  letter-spacing: -0.02em;
}
[data-theme="minimal"] .shop-header .accent-line {
  border-radius: 9999px;
  height: 4px;
}
[data-theme="minimal"] .pdp-add-to-cart {
  border-radius: 9999px;
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-size: 1rem;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-color: transparent;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  transition: all 0.2s ease;
}
[data-theme="minimal"] .pdp-add-to-cart:hover {
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  transform: translateY(-1px);
}
[data-theme="vintage"] {
  --font-display: "Playfair Display", "Georgia", serif;
  --font-heading: "Lora", "Georgia", serif;
  --font-editorial: "Playfair Display", "Georgia", serif;
  --font-body: "Lora", "Georgia", serif;
  --color-accent: #5c6b4f;
  --color-accent-hover: #4a5840;
  --color-accent-light: #f0f2ec;
  --color-surface: #faf6f1;
  --color-surface-alt: #f0ebe3;
  --color-surface-inverse: #2c1810;
  --color-text-primary: #4a3728;
  --color-text-heading: #2c1810;
  --color-text-secondary: #8c7b6b;
  --color-text-inverse: #faf6f1;
  --color-border-default: #ddd5c9;
  --color-border-strong: #2c1810;
  --color-btn-primary-bg: #2c1810;
  --color-btn-primary-text: #faf6f1;
  --color-btn-primary-border: #2c1810;
  --color-btn-primary-hover-bg: #5c6b4f;
  --color-btn-primary-hover-border: #5c6b4f;
  --radius-theme: 0px;
  --radius-theme-lg: 0px;
}
[data-theme="vintage"] .jp-btn-primary,
[data-theme="vintage"] .jp-btn-secondary,
[data-theme="vintage"] .jp-btn-ghost {
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 400;
  border-width: 1px;
  padding: 0.875rem 2rem;
  font-size: 0.8125rem;
}
[data-theme="vintage"] .jp-card {
  box-shadow: none;
  border-color: var(--color-border-default);
}
[data-theme="vintage"] .jp-card:hover {
  box-shadow: none;
  border-color: var(--color-accent);
}
[data-theme="vintage"] .jp-input,
[data-theme="vintage"] .jp-select {
  border-width: 1px;
  padding: 0.75rem 1rem;
}
[data-theme="vintage"] .jp-label {
  text-transform: none;
  letter-spacing: 0.03em;
  font-weight: 600;
  font-size: 0.75rem;
}
[data-theme="vintage"] main {
  display: flex;
  flex-direction: column;
}
[data-theme="vintage"] .hero-section {
  order: 1;
}
[data-theme="vintage"] .section-featured {
  order: 2;
}
[data-theme="vintage"] .section-explore {
  order: 3;
}
[data-theme="vintage"] .section-product-grid {
  order: 4;
}
[data-theme="vintage"] .section-promo-banner {
  order: 5;
}
[data-theme="vintage"] .section-mens {
  order: 6;
}
[data-theme="vintage"] .promo-badges {
  order: 7;
  display: none;
}
[data-theme="vintage"] .site-nav {
  border-bottom-width: 1px;
  border-bottom-color: var(--color-border-default);
}
[data-theme="vintage"] .announcement-bar {
  text-transform: none;
  letter-spacing: 0.08em;
  font-weight: 400;
  font-size: 0.6875rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
[data-theme="vintage"] .hero-section {
  background-color: var(--color-surface) !important;
  border-bottom: 1px solid var(--color-border-default);
}
[data-theme="vintage"] .hero-section .hero-grid {
  grid-template-columns: 1fr !important;
  min-height: auto !important;
  text-align: center;
}
[data-theme="vintage"] .hero-section .hero-grid > div:last-child {
  display: none;
}
[data-theme="vintage"] .hero-section .hero-text {
  order: 1;
  align-items: center;
  text-align: center;
  padding: 5rem 2rem 4rem;
  max-width: 640px;
  margin: 0 auto;
}
[data-theme="vintage"] .hero-section .accent-line {
  display: none;
}
[data-theme="vintage"] .hero-section .section-header-label {
  display: none;
}
[data-theme="vintage"] .hero-section .hero-text h1 {
  color: var(--color-text-heading);
  text-transform: none;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 1.05;
  font-style: italic;
  font-size: 3rem;
}
@media (min-width: 640px) {
  [data-theme="vintage"] .hero-section .hero-text h1 {
    font-size: 3.75rem;
  }
}
[data-theme="vintage"] .hero-section .hero-text p {
  color: var(--color-text-secondary);
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}
[data-theme="vintage"] .hero-section .hero-cta-primary {
  background-color: var(--color-btn-primary-bg);
  color: var(--color-btn-primary-text);
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 400;
  font-size: 0.8125rem;
  border: 1px solid var(--color-btn-primary-border);
  padding: 0.875rem 2.5rem;
}
[data-theme="vintage"] .hero-section .hero-cta-primary:hover {
  background-color: var(--color-btn-primary-hover-bg);
  border-color: var(--color-btn-primary-hover-border);
}
[data-theme="vintage"] .hero-section .hero-cta-secondary {
  color: var(--color-text-heading);
  border-color: var(--color-border-default);
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 400;
  font-size: 0.8125rem;
  border-width: 1px;
}
[data-theme="vintage"] .hero-section .hero-cta-secondary:hover {
  border-color: var(--color-text-heading);
  color: var(--color-text-heading);
}
[data-theme="vintage"] .section-header-label {
  font-family: "Lora", "Georgia", serif;
  font-style: italic;
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
}
[data-theme="vintage"] .section-header-title {
  text-transform: none;
  font-weight: 400;
  letter-spacing: -0.01em;
  font-style: italic;
  color: var(--color-text-heading);
}
[data-theme="vintage"] .section-featured {
  background-color: var(--color-surface);
  border-top: 1px solid var(--color-border-default);
  border-bottom: 1px solid var(--color-border-default);
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
[data-theme="vintage"] .section-featured .featured-grid {
  gap: 0;
}
@media (min-width: 1024px) {
  [data-theme="vintage"] .section-featured .featured-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
  }
}
[data-theme="vintage"] .section-featured .featured-grid > * {
  border-right: 1px solid var(--color-border-default);
  padding: 0 0.75rem;
}
[data-theme="vintage"] .section-featured .featured-grid > *:last-child {
  border-right: none;
}
[data-theme="vintage"] .section-explore {
  background-color: var(--color-surface-alt);
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  border-top: 1px solid var(--color-border-default);
  border-bottom: 1px solid var(--color-border-default);
}
[data-theme="vintage"] .section-explore .text-center.mb-14 {
  display: none;
}
[data-theme="vintage"] .section-explore .stat-value {
  font-weight: 400;
  font-style: italic;
  font-size: 2.25rem;
}
[data-theme="vintage"] .section-explore .grid.grid-cols-2.sm\\:grid-cols-4.gap-3 {
  display: none;
}
[data-theme="vintage"] .section-product-grid {
  background-color: var(--color-surface);
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
@media (min-width: 1024px) {
  [data-theme="vintage"] .section-product-grid .product-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
  }
}
@media (max-width: 1023px) {
  [data-theme="vintage"] .section-product-grid .product-grid {
    gap: 0;
  }
}
[data-theme="vintage"] .section-product-grid .product-grid > * {
  border-right: 1px solid var(--color-border-default);
  border-bottom: 1px solid var(--color-border-default);
  padding: 0.5rem;
}
[data-theme="vintage"] .section-product-grid .product-grid > *:nth-child(4n) {
  border-right: none;
}
@media (max-width: 1023px) and (min-width: 640px) {
  [data-theme="vintage"] .section-product-grid .product-grid > *:nth-child(3n) {
    border-right: none;
  }
}
@media (max-width: 639px) {
  [data-theme="vintage"] .section-product-grid .product-grid > *:nth-child(2n) {
    border-right: none;
  }
}
[data-theme="vintage"] .product-card {
  background-color: var(--color-surface);
  transition: border-color 0.3s ease;
}
[data-theme="vintage"] .product-card:hover {
  border-bottom: 2px solid var(--color-accent);
}
[data-theme="vintage"] .product-card img {
  transition: none !important;
  transform: none !important;
}
[data-theme="vintage"] .product-card:hover img {
  transform: none !important;
}
[data-theme="vintage"] .product-card .absolute.inset-0 {
  display: none;
}
[data-theme="vintage"] .product-card .quick-view-bar {
  display: none;
}
[data-theme="vintage"] .product-card .product-name {
  font-family: "Playfair Display", "Georgia", serif;
  font-weight: 400;
  font-style: italic;
  font-size: 0.9375rem;
  color: var(--color-text-heading);
}
[data-theme="vintage"] .product-card .product-price {
  font-family: "Lora", "Georgia", serif;
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
}
[data-theme="vintage"] .section-promo-banner {
  padding-top: 0;
  padding-bottom: 0;
}
[data-theme="vintage"] .section-promo-banner .promo-dark-panel {
  background-color: var(--color-surface-inverse);
}
[data-theme="vintage"] .section-promo-banner .promo-dark-panel .accent-line {
  background-color: var(--color-accent);
}
[data-theme="vintage"] .section-promo-banner .section-header-label {
  color: var(--color-accent);
}
[data-theme="vintage"] .section-promo-banner .section-header-title {
  color: var(--color-text-inverse);
}
[data-theme="vintage"] .section-mens {
  background-color: var(--color-surface-alt) !important;
  border-top: 1px solid var(--color-border-default);
}
[data-theme="vintage"] .section-mens h2 {
  color: var(--color-text-heading);
  text-transform: none;
  font-style: italic;
}
[data-theme="vintage"] .section-mens .section-header-label {
  color: var(--color-accent);
}
[data-theme="vintage"] .section-mens p {
  color: var(--color-text-secondary);
}
[data-theme="vintage"] .section-mens a[href="/shop/men"] {
  background-color: var(--color-btn-primary-bg);
  color: var(--color-btn-primary-text);
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 400;
}
[data-theme="vintage"] footer {
  background-color: var(--color-surface-alt) !important;
  border-top: 1px solid var(--color-border-default);
}
[data-theme="vintage"] footer h3 {
  color: var(--color-text-secondary);
  text-transform: none;
  letter-spacing: 0.06em;
}
[data-theme="vintage"] footer a,
[data-theme="vintage"] footer li,
[data-theme="vintage"] footer p,
[data-theme="vintage"] footer span {
  color: var(--color-text-secondary);
}
[data-theme="vintage"] footer a:hover {
  color: var(--color-text-heading);
}
[data-theme="vintage"] footer .font-display {
  color: var(--color-text-heading);
}
[data-theme="vintage"] footer .border-t {
  border-color: var(--color-border-default);
}
[data-theme="vintage"] .shop-header h1 {
  text-transform: none;
  font-style: italic;
  font-weight: 400;
}
[data-theme="vintage"] .shop-header .accent-line {
  background-color: var(--color-accent);
}
[data-theme="vintage"] .pdp-add-to-cart {
  text-transform: none;
  letter-spacing: 0.04em;
  font-weight: 400;
}
@layer base {
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--color-surface);
    color: var(--color-text-primary);
    font-feature-settings: "kern" 1,
      "liga" 1;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-heading);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
    color: var(--color-text-heading);
  }
}
@layer components {
  .jp-card {
    background-color: var(--color-surface);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-theme);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .jp-card:hover {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .jp-btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: calc(var(--spacing) * 6);
    padding-block: calc(var(--spacing) * 3);
    font-family: var(--font-heading);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
    background-color: var(--color-btn-primary-bg);
    color: var(--color-btn-primary-text);
    border: 2px solid var(--color-btn-primary-border);
    border-radius: var(--radius-theme);
    --tw-ring-color: var(--color-accent);
  }
  .jp-btn-primary:hover {
    background-color: var(--color-btn-primary-hover-bg);
    border-color: var(--color-btn-primary-hover-border);
  }
  .jp-btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: calc(var(--spacing) * 6);
    padding-block: calc(var(--spacing) * 3);
    font-family: var(--font-heading);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
    background-color: var(--color-surface);
    color: var(--color-text-heading);
    border: 2px solid var(--color-border-strong);
    border-radius: var(--radius-theme);
    --tw-ring-color: var(--color-accent);
  }
  .jp-btn-secondary:hover {
    background-color: var(--color-surface-inverse);
    color: var(--color-text-inverse);
  }
  .jp-btn-ghost {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2.5);
    font-family: var(--font-heading);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
    background-color: transparent;
    color: var(--color-text-secondary);
    border: 2px solid transparent;
    border-radius: var(--radius-theme);
    --tw-ring-color: var(--color-accent);
  }
  .jp-btn-ghost:hover {
    color: var(--color-text-heading);
    border-color: var(--color-border-strong);
  }
  .jp-btn-danger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: calc(var(--spacing) * 6);
    padding-block: calc(var(--spacing) * 3);
    background-color: var(--color-white);
    font-family: var(--font-heading);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    color: var(--color-shu-600);
    text-transform: uppercase;
    border-style: var(--tw-border-style);
    border-width: 2px;
    border-color: var(--color-shu-500);
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-shu-600);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-shu-600);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-shu-500);
    }
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
    border-radius: var(--radius-theme);
  }
  .jp-btn-success {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: calc(var(--spacing) * 6);
    padding-block: calc(var(--spacing) * 3);
    background-color: var(--color-matcha-600);
    font-family: var(--font-heading);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    color: var(--color-white);
    text-transform: uppercase;
    border-style: var(--tw-border-style);
    border-width: 2px;
    border-color: transparent;
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-matcha-700);
      }
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-matcha-500);
    }
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 200ms;
    transition-duration: 200ms;
    border-radius: var(--radius-theme);
  }
  .jp-badge {
    display: inline-flex;
    align-items: center;
    border-radius: calc(infinity * 1px);
    padding-inline: calc(var(--spacing) * 2.5);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .jp-badge-active {
    border-color: var(--color-matcha-200);
    background-color: var(--color-matcha-50);
    color: var(--color-matcha-700);
  }
  .jp-badge-sold {
    border-color: var(--color-indigo-jp-200);
    background-color: var(--color-indigo-jp-50);
    color: var(--color-indigo-jp-700);
  }
  .jp-badge-archived {
    border-color: var(--color-sumi-200);
    background-color: var(--color-sumi-100);
    color: var(--color-sumi-600);
  }
  .jp-input {
    display: block;
    width: 100%;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    color: var(--color-text-primary);
    background-color: var(--color-surface);
    border: 2px solid var(--color-border-default);
    border-radius: var(--radius-theme);
  }
  .jp-input::placeholder {
    color: var(--color-text-secondary);
  }
  .jp-input:focus {
    border-color: var(--color-border-strong);
  }
  .jp-select {
    display: block;
    width: 100%;
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    color: var(--color-text-primary);
    background-color: var(--color-surface);
    border: 2px solid var(--color-border-default);
    border-radius: var(--radius-theme);
  }
  .jp-select:focus {
    border-color: var(--color-border-strong);
  }
  .jp-label {
    margin-bottom: calc(var(--spacing) * 2);
    display: block;
    font-family: var(--font-heading);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
    text-transform: uppercase;
    color: var(--color-text-heading);
  }
  .jp-divider {
    border-top: 1px solid var(--color-border-default);
  }
  .jp-link {
    text-decoration-line: underline;
    text-underline-offset: 2px;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 150ms;
    transition-duration: 150ms;
    color: var(--color-text-heading);
  }
  .jp-link:hover {
    color: var(--color-accent);
  }
}
.rte-content .tiptap {
  outline: none;
  min-height: 120px;
}
.rte-content .tiptap h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0.5em 0;
}
.rte-content .tiptap h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0.5em 0;
}
.rte-content .tiptap ul {
  list-style: disc;
  padding-left: 1.5em;
}
.rte-content .tiptap ol {
  list-style: decimal;
  padding-left: 1.5em;
}
.rte-content .tiptap a {
  color: var(--color-sumi-900);
  text-decoration: underline;
}
.rte-content .tiptap p {
  margin: 0.25em 0;
}
.rte-content .tiptap blockquote {
  border-left: 3px solid var(--color-sumi-300);
  padding-left: 1em;
  color: var(--color-sumi-500);
  margin: 0.5em 0;
}
.rich-content h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0.75em 0 0.25em;
}
.rich-content h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0.75em 0 0.25em;
}
.rich-content ul {
  list-style: disc;
  padding-left: 1.5em;
  margin: 0.5em 0;
}
.rich-content ol {
  list-style: decimal;
  padding-left: 1.5em;
  margin: 0.5em 0;
}
.rich-content a {
  color: var(--color-sumi-900);
  text-decoration: underline;
}
.rich-content p {
  margin: 0.25em 0;
}
.rich-content blockquote {
  border-left: 3px solid var(--color-sumi-300);
  padding-left: 1em;
  color: var(--color-sumi-500);
  margin: 0.5em 0;
}
.noise-texture::before {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0.03;
  pointer-events: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 128px 128px;
}
@layer utilities {
  .shadow-jp {
    box-shadow: 0 1px 3px 0 rgba(26, 26, 23, 0.08),
      0 1px 2px 0 rgba(26, 26, 23, 0.06);
  }
  .shadow-jp-md {
    box-shadow: 0 4px 12px -2px rgba(26, 26, 23, 0.1),
      0 2px 4px -1px rgba(26, 26, 23, 0.06);
  }
  .font-display-xl {
    font-family: var(--font-display);
    letter-spacing: 0.02em;
    line-height: 0.9;
  }
}
@keyframes cart-throb {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.6);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.animate-cart-throb {
  animation: cart-throb 1s ease-in-out;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./../node_modules/tailwindcss/index.css","webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,kEAAA;AC83BE,iBAAmB;AA93BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;ICG3D,6EAA8E;IDG5E,wCAAwC;IACxC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IA6B1C,8CAA8C;IAM9C,6CAA6C;IAC7C,6CAA6C;IAgB7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAI7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAqD7C,4CAA4C;IAM5C,4CAA4C;IAC5C,4CAA4C;IAK5C,4CAA4C;IAM5C,6CAA6C;IAC7C,8CAA8C;IAgH9C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAG3C,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IAErB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,0BAA0B;IAQ1B,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAKvB,0BAA0B;IAE1B,wBAAwB;IACxB,wBAAwB;IAMxB,wBAAwB;IAKxB,qBAAqB;IA0CrB,sCAAsC;IAKtC,+DAA+D;IAC/D,oCAAoC;IAoCpC,cAAc;IACd,eAAe;IAcf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IC1c3D,gEAAiE;IACjE,6DAA8D;IAM9D,qCAAsC;IAGtC,qCAAsC;IACtC,0CAA2C;IAC3C,kDAAmD;IACnD,+CAAgD;IAChD,+CAAgD;IAChD,6CAA8C;IAC9C,0CAA2C;IAC3C,6CAA8C;IAC9C,gDAAiD;IACjD,iDAAkD;IAClD,8CAA+C;IAC/C,qDAAsD;IACtD,mDAAoD;IACpD,uDAAwD;IAGxD,mBAAoB;IAepB,6BAA8B;IAC9B,6BAA8B;IAC9B,6BAA8B;IAC9B,6BAA8B;IAC9B,6BAA8B;IAC9B,6BAA8B;IAC9B,6BAA8B;IAG9B,wBAAyB;IACzB,yBAA0B;IAC1B,yBAA0B;IAO1B,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAE1B,yBAA0B;IAI1B,wBAAyB;IAGzB,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAO1B,0BAA2B;IAC3B,0BAA2B;IAC3B,0BAA2B;IAC3B,0BAA2B;IAQ3B,yBAA0B;IAE1B,yBAA0B;IAI1B,6BAA8B;IAE9B,8BAA+B;IAK/B,8BAA+B;IAC/B,8BAA+B;IAK/B,uBAAwB;IAExB,wBAAyB;IAGzB,wBAAyB;IACzB,wBAAyB;IACzB,wBAAyB;IAOzB,0BAA2B;IAO3B,0BAA2B;IAE3B,2BAA4B;IAG5B,2BAA4B;IAC5B,2BAA4B;IAC5B,2BAA4B;IAK5B,wBAAyB;IACzB,yBAA0B;IAC1B,yBAA0B;IAC1B,yBAA0B;IAE1B,yBAA0B;IAC1B,yBAA0B;IAG1B,yBAA0B;ED5JX;AADJ;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,kBAAmB;IAAnB,kBAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,mEAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB,sDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kBAAmB;QAAnB,kBAAmB;QAAnB,kBAAmB;QAAnB,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;MAAnB;QAAA,kEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gFAAmB;QAAnB;UAAA,8EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,cAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;AADJ;AC9sBjB;EACE,+DAAgE;EAChE,+DAAgE;EAChE,iEAAkE;EAClE,2DAA4D;EAG5D,uBAAwB;EACxB,6BAA8B;EAC9B,6BAA8B;EAC9B,wBAAyB;EACzB,4BAA6B;EAC7B,gCAAiC;EACjC,6BAA8B;EAC9B,6BAA8B;EAC9B,+BAAgC;EAChC,6BAA8B;EAC9B,+BAAgC;EAChC,8BAA+B;EAC/B,+BAAgC;EAChC,iCAAkC;EAClC,mCAAoC;EACpC,qCAAsC;EACtC,yCAA0C;EAE1C,oBAAqB;EACrB,uBAAwB;AACzB;AAKD;EACE,qBAAsB;EACtB,qBAAsB;EACtB,gBAAiB;EACjB,mBAAoB;EACpB,oBAAqB;EACrB,sBAAuB;EACvB,qDAAsD;EACtD,yBAA0B;EAC1B,+CAAgD;EAChD,yBAA0B;AAC3B;AACD;EACE,+CAAgD;EAChD,2BAA4B;AAC7B;AAED;;EAEE,qBAAsB;EACtB,qBAAsB;EACtB,gBAAiB;EACjB,mBAAoB;EACpB,oBAAqB;EACrB,sBAAuB;AACxB;AAGD;EACE,kCAAmC;EACnC;kCAEiC;EACjC,yBAA0B;EAC1B,0BAA2B;AAC5B;AACD;EACE;kCAEiC;EACjC,2BAA4B;AAC7B;AAGD;;EAEE,kCAAmC;EACnC,yCAA0C;EAC1C,qBAAsB;EACtB;mBAEkB;AACnB;AACD;;EAEE,iCAAkC;EAClC,8CAA+C;AAChD;AAGD;EACE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,oBAAqB;EACrB,gCAAiC;AAClC;AAGD;EACE,mBAAoB;EACpB,yCAA0C;AAC3C;AAGD;EACE,qDAAsD;EACtD,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,kBAAmB;EACnB,gBAAiB;AAClB;AAMD;EACE,qFAAsF;EACtF,4BAA6B;EAC7B,gBAAiB;AAClB;AAED;EACE,4BAA6B;AAC9B;AACD;EACE;IACE,4BAA6B;EAC9B;AACF;AAGD;EACE,+BAAgC;AACjC;AACD;EACE,qBAAsB;AACvB;AAGD;EACE,qBAAsB;EACtB,WAAY;EACZ,WAAY;AACb;AAGD;EACE,2CAA4C;EAC5C,qBAAsB;EACtB,sBAAuB;EACvB,qBAAsB;EACtB,oBAAqB;EACrB,sBAAuB;EACvB,kBAAmB;EACnB,+BAAgC;EAChC,mBAAoB;AACrB;AAED;EACE,oBAAqB;EACrB,uBAAwB;EACxB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,gCAAiC;EACjC,gDAAiD;AAClD;AAGD;EACE,gEAAiE;EACjE,YAAa;EACb,qBAAsB;EACtB,oBAAqB;EACrB,gBAAiB;EACjB,oBAAqB;EACrB,oBAAqB;EACrB,sBAAuB;EACvB,8CAA+C;EAC/C,yBAA0B;AAC3B;AACD;EACE,8CAA+C;EAC/C,2BAA4B;AAC7B;AAGD;EACE,qBAAsB;EACtB,iBAAkB;EAClB,sCAAuC;EACvC,oBAAqB;EACrB,gBAAiB;EACjB,oBAAqB;EACrB,oBAAqB;EACrB,sBAAuB;AACxB;AACD;EACE,0CAA2C;EAC3C,sCAAuC;AACxC;AAMD;EACE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,oBAAqB;EACrB,0BAA2B;AAC5B;AAED;EACE,oBAAqB;EACrB,gBAAiB;EACjB,uBAAwB;EACxB,eAAgB;AACjB;AACD;EACE;IACE,iBAAkB;EACnB;AACF;AAMD;EACE,0CAA2C;EAC3C,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,WAAY;AACb;AAMD;EACE,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,kCAAmC;EACnC,YAAa;EACb;kCAEiC;EACjC,0BAA2B;AAC5B;AACD;EACE;kCAEiC;EACjC,2BAA4B;AAC7B;AAGD;EACE,mBAAoB;AACrB;AAMD;EACE,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,qBAAsB;EACtB,gBAAiB;AAClB;AAED;EACE,qDAAsD;AACvD;AAED;EACE,qBAAsB;EACtB,WAAY;EACZ,qDAAsD;AACvD;AAED;EACE,cAAe;AAChB;AAED;EACE,YAAa;EACb,oBAAqB;EACrB,gBAAiB;AAClB;AAED;EACE,qBAAsB;EACtB,qDAAsD;EACtD,oBAAqB;EACrB,gBAAiB;EACjB,sBAAuB;EACvB,+CAAgD;AACjD;AAMD;EACE,yBAA0B;AAC3B;AAED;EACE,gBAAiB;EACjB,0BAA2B;EAC3B,eAAgB;AACjB;AAGD;EACE,kCAAmC;AACpC;AAMD;EACE,0CAA2C;EAC3C,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,WAAY;AACb;AAMD;EACE,kCAAmC;EACnC,gBAAiB;EACjB;kCAEiC;EACjC,YAAa;EACb,0BAA2B;AAC5B;AACD;EACE;mCAEkC;EAClC,2BAA4B;AAC7B;AAGD;EACE,qDAAsD;EACtD,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,oBAAqB;EACrB,oBAAqB;AACtB;AAED;EACE,gBAAiB;EACjB,0BAA2B;EAC3B,oBAAqB;AACtB;AAMD;EACE,wEAAyE;EACzE,gBAAiB;AAClB;AAED;EACE,oBAAqB;EACrB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,cAAe;AAChB;AAGD;EACE,qBAAsB;EACtB,qDAAsD;EACtD,oBAAqB;EACrB,gBAAiB;EACjB,sBAAuB;EACvB,+CAAgD;AACjD;AAMD;EACE,qDAAsD;EACtD,iDAAkD;AACnD;AAED;EACE,gCAAiC;AAClC;AAED;EACE,gCAAiC;EACjC,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;AAClB;AAED;;;;EAIE,gCAAiC;AAClC;AAED;EACE,0BAA2B;AAC5B;AAED;EACE,yCAA0C;AAC3C;AAMD;EACE,oBAAqB;EACrB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,qBAAsB;EACtB,WAAY;AACb;AAMD;EACE,qBAAsB;EACtB,oBAAqB;EACrB,gBAAiB;EACjB,sBAAuB;EACvB,eAAgB;EAChB,kBAAmB;EACnB,qDAAsD;EACtD,yBAA0B;EAC1B,+CAAgD;EAChD,yBAA0B;AAC3B;AACD;EACE,+CAAgD;EAChD,2BAA4B;AAC7B;AAKD;EACE,oDAAqD;EACrD,wCAAyC;EACzC,sDAAuD;EACvD,qCAAsC;EAGtC,uBAAwB;EACxB,6BAA8B;EAC9B,6BAA8B;EAC9B,wBAAyB;EACzB,4BAA6B;EAC7B,gCAAiC;EACjC,6BAA8B;EAC9B,6BAA8B;EAC9B,+BAAgC;EAChC,6BAA8B;EAC9B,+BAAgC;EAChC,8BAA+B;EAC/B,+BAAgC;EAChC,iCAAkC;EAClC,mCAAoC;EACpC,qCAAsC;EACtC,yCAA0C;EAE1C,mBAAoB;EACpB,sBAAuB;AACxB;AAUD;;;EAGE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,iBAAkB;EAClB,sBAAuB;EACvB,oBAAqB;AACtB;AAED;EACE,gBAAiB;EACjB,yCAA0C;AAC3C;AACD;EACE,gBAAiB;EACjB,iCAAkC;AACnC;AAED;;EAEE,iBAAkB;EAClB,qBAAsB;AACvB;AAED;EACE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,kBAAmB;AACpB;AAGD;EACE,aAAc;EACd,sBAAuB;AACxB;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;AACV;AACD;EACE,QAAS;EACT,aAAc;AACf;AAGD;EACE,wBAAyB;EACzB,gDAAiD;AAClD;AAGD;EACE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,oBAAqB;EACrB,mBAAoB;EACpB,sBAAuB;AACxB;AAOD;EACE,iDAAkD;EAClD,oDAAqD;AACtD;AAED;EACE,qCAAsC;EACtC,2BAA4B;EAC5B,kBAAmB;AACpB;AAGD;EACE,aAAc;AACf;AAGD;EACE,QAAS;EACT,mBAAoB;EACpB,kBAAmB;EACnB,uBAAwB;EACxB,gBAAiB;EACjB,cAAe;AAChB;AAGD;EACE,aAAc;AACf;AAGD;EACE,aAAc;AACf;AAED;EACE,gCAAiC;EACjC,oBAAqB;EACrB,gBAAiB;EACjB,uBAAwB;EACxB,iBAAkB;EAClB,kBAAmB;EACnB,eAAgB;AACjB;AACD;EACE;IACE,kBAAmB;EACpB;AACF;AAED;EACE,kCAAmC;EACnC,gBAAiB;EACjB,iBAAkB;EAClB,kBAAmB;AACpB;AAGD;EACE,6CAA8C;EAC9C,oCAAqC;EACrC,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,oBAAqB;EACrB,iDAAkD;EAClD,wBAAyB;AAC1B;AACD;EACE,mDAAoD;EACpD,mDAAoD;AACrD;AAGD;EACE,gCAAiC;EACjC,yCAA0C;EAC1C,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,oBAAqB;EACrB,iBAAkB;AACnB;AACD;EACE,uCAAwC;EACxC,gCAAiC;AAClC;AAMD;EACE,qCAAsC;EACtC,kBAAmB;EACnB,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;EACjB,mBAAoB;EACpB,kCAAmC;AACpC;AAED;EACE,oBAAqB;EACrB,gBAAiB;EACjB,uBAAwB;EACxB,kBAAmB;EACnB,gCAAiC;AAClC;AAOD;EACE,sCAAuC;EACvC,iDAAkD;EAClD,oDAAqD;EACrD,mBAAoB;EACpB,sBAAuB;AACxB;AAED;EACE,MAAO;AACR;AACD;EACE;IACE,qCAAsC;IACtC,MAAO;EACR;AACF;AAGD;EACE,mDAAoD;EACpD,kBAAmB;AACpB;AACD;EACE,kBAAmB;AACpB;AAMD;EACE,0CAA2C;EAC3C,mBAAoB;EACpB,sBAAuB;EACvB,iDAAkD;EAClD,oDAAqD;AACtD;AAGD;EACE,aAAc;AACf;AAGD;EACE,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;AACpB;AAGD;EACE,aAAc;AACf;AAMD;EACE,sCAAuC;EACvC,mBAAoB;EACpB,sBAAuB;AACxB;AAED;EACE;IACE,qCAAsC;IACtC,MAAO;EACR;AACF;AACD;EACE;IACE,MAAO;EACR;AACF;AAGD;EACE,mDAAoD;EACpD,oDAAqD;EACrD,eAAgB;AACjB;AACD;EACE,kBAAmB;AACpB;AACD;EACE;IACE,kBAAmB;EACpB;AACF;AACD;EACE;IACE,kBAAmB;EACpB;AACF;AAOD;EACE,sCAAuC;EACvC,kCAAmC;AACpC;AACD;EACE,4CAA6C;AAC9C;AAGD;EACE,2BAA4B;EAC5B,0BAA2B;AAC5B;AACD;EACE,0BAA2B;AAC5B;AAGD;EACE,aAAc;AACf;AAGD;EACE,aAAc;AACf;AAED;EACE,iDAAkD;EAClD,gBAAiB;EACjB,kBAAmB;EACnB,oBAAqB;EACrB,gCAAiC;AAClC;AAED;EACE,qCAAsC;EACtC,kCAAmC;EACnC,oBAAqB;AACtB;AAMD;EACE,cAAe;EACf,iBAAkB;AACnB;AAED;EACE,8CAA+C;AAChD;AAED;EACE,qCAAsC;AACvC;AAED;EACE,0BAA2B;AAC5B;AAED;EACE,gCAAiC;AAClC;AAOD;EACE,qDAAsD;EACtD,iDAAkD;AACnD;AAED;EACE,gCAAiC;EACjC,oBAAqB;EACrB,kBAAmB;AACpB;AAED;EACE,0BAA2B;AAC5B;AAED;EACE,kCAAmC;AACpC;AAGD;EACE,6CAA8C;EAC9C,oCAAqC;EACrC,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;AAClB;AAMD;EACE,qDAAsD;EACtD,iDAAkD;AACnD;AAED;EACE,kCAAmC;EACnC,oBAAqB;EACrB,sBAAuB;AACxB;AAED;;;;EAIE,kCAAmC;AACpC;AAED;EACE,gCAAiC;AAClC;AAED;EACE,gCAAiC;AAClC;AAED;EACE,yCAA0C;AAC3C;AAMD;EACE,oBAAqB;EACrB,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,qCAAsC;AACvC;AAMD;EACE,oBAAqB;EACrB,sBAAuB;EACvB,gBAAiB;AAClB;AAGD;EACE;IACS,mCAAW;IAAX,kCAAW;IAClB,sCAAuC;IACvC,gCAAiC;IACjC;cAEW;EACZ;EAED;;;;;;IAMS,gCAAY;IAAC,oCAAc;IAAd,qCAAc;IAClC,gCAAiC;EAClC;AACF;AAGD;EAEE;IACE,sCAAuC;IACvC,6CAA8C;IAC9C,kCAAmC;IAC5B,0HAAS;IAAT,sIAAS;IAAC,+BAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC,oBAAY;IAAZ,0BAAY;EAChD;EAED;IACS,+HAAS;IAAT,sIAAS;EACjB;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,uCAAI;IACjD,gCAAY;IAAe,yBAAO;IAAP,2DAAO;IAArB,6CAAa;IAAb,wCAAa;IAAmB,oCAAc;IAAd,qCAAc;IAAxB,yBAAS;IACzB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;IAAnD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAClB,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAClC,6CAA8C;IAC9C,oCAAqC;IACrC,iDAAkD;IAClD,kCAAmC;IACnC,oCAAqC;EACtC;EACD;IACE,mDAAoD;IACpD,mDAAoD;EACrD;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,uCAAI;IACjD,gCAAY;IAAe,yBAAO;IAAP,2DAAO;IAArB,6CAAa;IAAb,wCAAa;IAAmB,oCAAc;IAAd,qCAAc;IAAxB,yBAAS;IACzB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;IAAnD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAClB,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAClC,sCAAuC;IACvC,gCAAiC;IACjC,4CAA6C;IAC7C,kCAAmC;IACnC,oCAAqC;EACtC;EACD;IACE,8CAA+C;IAC/C,gCAAiC;EAClC;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,yCAAM;IACnD,gCAAY;IAAe,yBAAO;IAAP,2DAAO;IAArB,6CAAa;IAAb,wCAAa;IAAmB,oCAAc;IAAd,qCAAc;IAAxB,yBAAS;IACzB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;IAAnD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAClB,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAClC,6BAA8B;IAC9B,kCAAmC;IACnC,6BAA8B;IAC9B,kCAAmC;IACnC,oCAAqC;EACtC;EACD;IACE,gCAAiC;IACjC,wCAAyC;EAC1C;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,uCAAI;IACjD,oCAAQ;IAAc,gCAAY;IAAe,yBAAO;IAAP,2DAAO;IAArB,6CAAa;IAAb,wCAAa;IAAmB,oCAAc;IAAd,qCAAc;IAAxE,2BAAY;IAAoC,yBAAS;IAClE,oCAAQ;IAAR,iBAAQ;IAAC,kCAAc;IACW;MAAA;QAAA,kCAAoB;MAAA;IAAA;IAAtD;MAAA;QAAA,sCAAgB;MAAA;IAAA;IAAC;MAAA;QAAA,yBAAgB;MAAA;IAAA;IAAyC;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,qCAAkB;IAAA;IAAC;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;IAAtE;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IACzE,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAClC,kCAAmC;EACpC;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,wCAAI;IAAC,uCAAI;IACjD,yCAAa;IAAY,gCAAY;IAAe,yBAAO;IAAP,2DAAO;IAArB,6CAAa;IAAb,wCAAa;IAAmB,oCAAc;IAAd,qCAAc;IAAtE,yBAAU;IAAoC,yBAAS;IACrE,oCAAQ;IAAR,iBAAQ;IAAC,yBAAkB;IAC3B;MAAA;QAAA,yCAAmB;MAAA;IAAA;IAAoB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,wCAAqB;IAAA;IAAC;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;IAAzE;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IACtC,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAClC,kCAAmC;EACpC;EAGD;IACS,oBAAW;IAAC,mBAAY;IAAe,mCAAY;IAA1B,0CAAM;IAAC,yCAAM;IAAc,yBAAO;IAAP,2DAAO;IAAC,yCAAS;IAAT,oCAAS;IAAW,oCAAc;IAAd,qCAAc;IAAxB,yBAAS;IAC/E,oCAAM;IAAN,iBAAM;EACd;EAED;IACsC,qCAAiB;IAA9C,wCAAY;IAAC,8BAAe;EACpC;EAED;IAC4C,wCAAoB;IAAvD,2CAAe;IAAC,iCAAkB;EAC1C;EAED;IACmC,mCAAe;IAAzC,uCAAW;IAAC,4BAAa;EACjC;EAGD;IACS,cAAK;IAAC,WAAM;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAChC;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAClB,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC,oBAAY;IAAZ,0BAAY;IACrC,gCAAiC;IACjC,sCAAuC;IACvC,6CAA8C;IAC9C,kCAAmC;EACpC;EACD;IACE,kCAAmC;EACpC;EACD;IACE,wCAAyC;EAC1C;EAED;IACS,cAAK;IAAC,WAAM;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAChC;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAClB,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC,oBAAY;IAAZ,0BAAY;IACrC,gCAAiC;IACjC,sCAAuC;IACvC,6CAA8C;IAC9C,kCAAmC;EACpC;EACD;IACE,wCAAyC;EAC1C;EAED;IAC2E,uCAAI;IAAtE,cAAK;IAAS,gCAAY;IAApB,yBAAO;IAAP,2DAAO;IAAc,6CAAa;IAAb,wCAAa;IAAW,oCAAc;IAAd,qCAAc;IAAxB,yBAAS;IACzD,gCAAiC;EAClC;EAGD;IACE,iDAAkD;EACnD;EAGD;IACS,+BAAS;IAAC,0BAAkB;IAC5B,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC,oBAAY;IAAZ,0BAAY;IACrC,gCAAiC;EAClC;EACD;IACE,0BAA2B;EAC5B;AACF;AAGD;EACE,aAAc;EACd,iBAAkB;AACnB;AACD;EACE,kBAAmB;EACnB,gBAAiB;EACjB,eAAgB;AACjB;AACD;EACE,iBAAkB;EAClB,gBAAiB;EACjB,eAAgB;AACjB;AACD;EACE,gBAAiB;EACjB,mBAAoB;AACrB;AACD;EACE,mBAAoB;EACpB,mBAAoB;AACrB;AACD;EACE,4BAA6B;EAC7B,0BAA2B;AAC5B;AACD;EACE,gBAAiB;AAClB;AACD;EACE,4CAA6C;EAC7C,iBAAkB;EAClB,4BAA6B;EAC7B,eAAgB;AACjB;AAGD;EACE,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;AACzB;AACD;EACE,iBAAkB;EAClB,gBAAiB;EACjB,uBAAwB;AACzB;AACD;EACE,gBAAiB;EACjB,mBAAoB;EACpB,eAAgB;AACjB;AACD;EACE,mBAAoB;EACpB,mBAAoB;EACpB,eAAgB;AACjB;AACD;EACE,4BAA6B;EAC7B,0BAA2B;AAC5B;AACD;EACE,gBAAiB;AAClB;AACD;EACE,4CAA6C;EAC7C,iBAAkB;EAClB,4BAA6B;EAC7B,eAAgB;AACjB;AAGD;EACE,WAAY;EACZ,kBAAmB;EACnB,QAAS;EACT,aAAc;EACd,oBAAqB;EACrB,yDAAqT;EACrT,4BAA6B;AAC9B;AAGD;EACE;IACE;wCAEqC;EACtC;EAED;IACE;2CAEwC;EACzC;EAGD;IACE,gCAAiC;IACjC,sBAAuB;IACvB,gBAAiB;EAClB;AACF;AAED;EACE;IACE,mBAAoB;EACrB;EACD;IACE,qBAAsB;EACvB;EACD;IACE,qBAAsB;EACvB;EACD;IACE,qBAAsB;EACvB;EACD;IACE,mBAAoB;EACrB;AACF;AAED;EACE,oCAAqC;AACtC;AD9jBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA7djB;EACE;IACE,YAAY;EADV;AADW;AAMjB;EACE;IAEE,2BAA2B;IAC3B,qDAAqD;EAFlD;EAKL;IACE,eAAe;IACf,qDAAqD;EAFnD;AAPY;AAudpB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n\n/* Multi-theme system — semantic tokens + palette */\n@theme {\n  /* Font families — Elevated brand defaults. Per-theme overrides live in data-theme blocks below. */\n  --font-display: \"Fraunces\", \"Cormorant Garamond\", Georgia, serif;\n  --font-heading: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  --font-editorial: \"Fraunces\", \"Playfair Display\", Georgia, serif;\n  --font-body: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  --font-mono: \"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, monospace;\n\n  /* Semantic color tokens — components reference these */\n  --color-accent: var(--color-clay-500);\n  --color-accent-hover: var(--color-clay-600);\n  --color-accent-light: var(--color-clay-50);\n  --color-surface: var(--color-bone-50);\n  --color-surface-alt: var(--color-bone-100);\n  --color-surface-inverse: var(--color-obsidian-900);\n  --color-text-primary: var(--color-obsidian-800);\n  --color-text-heading: var(--color-obsidian-900);\n  --color-text-secondary: var(--color-dune-600);\n  --color-text-inverse: var(--color-bone-50);\n  --color-border-default: var(--color-dune-200);\n  --color-border-strong: var(--color-obsidian-900);\n  --color-btn-primary-bg: var(--color-obsidian-900);\n  --color-btn-primary-text: var(--color-bone-50);\n  --color-btn-primary-border: var(--color-obsidian-900);\n  --color-btn-primary-hover-bg: var(--color-clay-500);\n  --color-btn-primary-hover-border: var(--color-clay-500);\n\n  /* Theme geometry */\n  --radius-theme: 0px;\n  --radius-theme-lg: 0px;\n\n  /* ═══════════════════════════════════════════════════════════\n     ELEVATED BRAND PALETTE — desert at dusk\n     Obsidian (volcanic dark) · Bone (warm paper) · Dune (sand\n     mid-tones) · Clay (terracotta, primary accent) · Ember\n     (glowing ochre highlight) · Sage (restrained cool).\n     ═══════════════════════════════════════════════════════════ */\n\n  /* Obsidian — deep warm near-blacks for hero + materials surfaces */\n  --color-obsidian-50: #faf5ec;\n  --color-obsidian-100: #f1e6d1;\n  --color-obsidian-200: #d9c4a0;\n  --color-obsidian-300: #b89b73;\n  --color-obsidian-400: #8e7454;\n  --color-obsidian-500: #6a543c;\n  --color-obsidian-600: #4c3c2b;\n  --color-obsidian-700: #352a1e;\n  --color-obsidian-800: #221a13;\n  --color-obsidian-900: #14100b;\n  --color-obsidian-950: #0a0705;\n\n  /* Bone — warm cream paper, used for editorial light surfaces */\n  --color-bone-50: #fbf7ef;\n  --color-bone-100: #f6efdf;\n  --color-bone-200: #efe0c4;\n  --color-bone-300: #e3cda0;\n  --color-bone-400: #d3b476;\n  --color-bone-500: #b99655;\n\n  /* Dune — sand mid-tones for borders, secondary text, hairlines */\n  --color-dune-50: #f5ede0;\n  --color-dune-100: #e9dcc2;\n  --color-dune-200: #d6c39f;\n  --color-dune-300: #bfa477;\n  --color-dune-400: #a3855a;\n  --color-dune-500: #836a47;\n  --color-dune-600: #635038;\n  --color-dune-700: #46392a;\n\n  /* Clay — terracotta / rust primary accent */\n  --color-clay-50: #faf0e8;\n  --color-clay-100: #f2d9c3;\n  --color-clay-200: #e5b994;\n  --color-clay-300: #d2945e;\n  --color-clay-400: #bc7337;\n  --color-clay-500: #a2581f;\n  --color-clay-600: #854319;\n  --color-clay-700: #673214;\n  --color-clay-800: #4a240f;\n  --color-clay-900: #31180a;\n\n  /* Ember — glowing ochre highlight for eyebrows and small accents */\n  --color-ember-50: #fdf4e4;\n  --color-ember-100: #fae4bd;\n  --color-ember-200: #f4c775;\n  --color-ember-300: #eca23d;\n  --color-ember-400: #dc8420;\n  --color-ember-500: #b66718;\n  --color-ember-600: #8e4f14;\n  --color-ember-700: #663910;\n\n  /* Sage — dusty desert sage for \"in stock\" / subtle success states */\n  --color-sage-50: #f0f1ea;\n  --color-sage-100: #dde0cc;\n  --color-sage-200: #bdc4a3;\n  --color-sage-300: #95a077;\n  --color-sage-400: #6e7a54;\n  --color-sage-500: #535f3f;\n  --color-sage-600: #3e472e;\n\n  /* Japanese Indigo (Ai) - Secondary/subtle */\n  --color-indigo-jp-50: #f6f7f9;\n  --color-indigo-jp-100: #eaedf2;\n  --color-indigo-jp-200: #d2dae5;\n  --color-indigo-jp-300: #a6b5ce;\n  --color-indigo-jp-400: #7590b3;\n  --color-indigo-jp-500: #546e94;\n  --color-indigo-jp-600: #3d5578;\n  --color-indigo-jp-700: #2d4562;\n  --color-indigo-jp-800: #1e3a5f;\n  --color-indigo-jp-900: #182d4a;\n  --color-indigo-jp-950: #0f1d30;\n\n  /* Vermillion Red (Shu) - Primary accent */\n  --color-shu-50: #fef5f5;\n  --color-shu-100: #fde8e8;\n  --color-shu-200: #fbd5d5;\n  --color-shu-300: #f8b4b6;\n  --color-shu-400: #f28b8e;\n  --color-shu-500: #e85c60;\n  --color-shu-600: #c53d43;\n  --color-shu-700: #a73135;\n  --color-shu-800: #8a2b2e;\n  --color-shu-900: #72282b;\n  --color-shu-950: #3e1112;\n\n  /* Washi Paper (Background) */\n  --color-washi-50: #fdfcfb;\n  --color-washi-100: #faf8f5;\n  --color-washi-200: #f5f2ed;\n  --color-washi-300: #ebe6de;\n  --color-washi-400: #d9d1c4;\n  --color-washi-500: #c4b9a9;\n\n  /* Matcha Green — reserved for success states only */\n  --color-matcha-50: #f5f7f4;\n  --color-matcha-100: #e8ece6;\n  --color-matcha-200: #d1dace;\n  --color-matcha-300: #adbda8;\n  --color-matcha-400: #8a9e83;\n  --color-matcha-500: #7d8c6e;\n  --color-matcha-600: #5f7054;\n  --color-matcha-700: #4c5a44;\n  --color-matcha-800: #3f4a39;\n  --color-matcha-900: #353e31;\n\n  /* Sumi Ink (Text) */\n  --color-sumi-50: #f8f8f7;\n  --color-sumi-100: #eeeeec;\n  --color-sumi-200: #d9d9d6;\n  --color-sumi-300: #b8b8b3;\n  --color-sumi-400: #8f8f88;\n  --color-sumi-500: #6b6b64;\n  --color-sumi-600: #4d4d47;\n  --color-sumi-700: #3d3d38;\n  --color-sumi-800: #2d2d29;\n  --color-sumi-900: #1a1a17;\n\n  /* Custom border radius */\n  --radius-jp: 4px;\n  --radius-jp-lg: 6px;\n\n  /* Custom spacing */\n  --spacing-18: 4.5rem;\n  --spacing-88: 22rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   MINIMAL THEME — \"Starter Store\"\n   Classic WordPress/WooCommerce vibes. Friendly, rounded,\n   soft shadows, trustworthy. The theme your aunt loves.\n   ═══════════════════════════════════════════════════════════ */\n[data-theme=\"minimal\"] {\n  --font-display: \"Poppins\", ui-sans-serif, system-ui, sans-serif;\n  --font-heading: \"Poppins\", ui-sans-serif, system-ui, sans-serif;\n  --font-editorial: \"Poppins\", ui-sans-serif, system-ui, sans-serif;\n  --font-body: \"Nunito\", ui-sans-serif, system-ui, sans-serif;\n\n  /* Friendly indigo — trustworthy, modern, WooCommerce energy */\n  --color-accent: #6366f1;\n  --color-accent-hover: #4f46e5;\n  --color-accent-light: #eef2ff;\n  --color-surface: #ffffff;\n  --color-surface-alt: #f8fafc;\n  --color-surface-inverse: #1e1b4b;\n  --color-text-primary: #475569;\n  --color-text-heading: #1e293b;\n  --color-text-secondary: #94a3b8;\n  --color-text-inverse: #ffffff;\n  --color-border-default: #e2e8f0;\n  --color-border-strong: #1e293b;\n  --color-btn-primary-bg: #6366f1;\n  --color-btn-primary-text: #ffffff;\n  --color-btn-primary-border: #6366f1;\n  --color-btn-primary-hover-bg: #4f46e5;\n  --color-btn-primary-hover-border: #4f46e5;\n\n  --radius-theme: 12px;\n  --radius-theme-lg: 16px;\n}\n\n/* ─── Minimal: Component base overrides ─── */\n\n/* Buttons — pill-shaped, friendly, with gradient and soft shadow */\n[data-theme=\"minimal\"] .jp-btn-primary {\n  border-radius: 9999px;\n  padding: 0.75rem 2rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  border-color: transparent;\n  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);\n  transition: all 0.2s ease;\n}\n[data-theme=\"minimal\"] .jp-btn-primary:hover {\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);\n  transform: translateY(-1px);\n}\n\n[data-theme=\"minimal\"] .jp-btn-secondary,\n[data-theme=\"minimal\"] .jp-btn-ghost {\n  border-radius: 9999px;\n  padding: 0.75rem 2rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-transform: none;\n  letter-spacing: 0.01em;\n}\n\n/* Cards — rounded, soft shadow, hover lift */\n[data-theme=\"minimal\"] .jp-card {\n  border-radius: var(--radius-theme);\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.06),\n    0 4px 12px rgba(0, 0, 0, 0.04);\n  border-color: transparent;\n  transition: all 0.25s ease;\n}\n[data-theme=\"minimal\"] .jp-card:hover {\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.08),\n    0 8px 32px rgba(0, 0, 0, 0.06);\n  transform: translateY(-2px);\n}\n\n/* Inputs — rounded, soft border */\n[data-theme=\"minimal\"] .jp-input,\n[data-theme=\"minimal\"] .jp-select {\n  border-radius: var(--radius-theme);\n  border-color: var(--color-border-default);\n  padding: 0.75rem 1rem;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n[data-theme=\"minimal\"] .jp-input:focus,\n[data-theme=\"minimal\"] .jp-select:focus {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n/* Labels — friendly sentence case */\n[data-theme=\"minimal\"] .jp-label {\n  text-transform: none;\n  letter-spacing: 0.01em;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: var(--color-text-heading);\n}\n\n/* ─── Minimal: Navbar — rounded bottom, soft shadow, no hard border ─── */\n[data-theme=\"minimal\"] .site-nav {\n  border-bottom: none;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n/* ─── Minimal: Announcement bar — gradient, rounded feel ─── */\n[data-theme=\"minimal\"] .announcement-bar {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 600;\n  font-size: 0.75rem;\n  border-radius: 0;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HERO — Friendly split with gradient bg, rounded image\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .hero-section {\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 40%, #4338ca 100%) !important;\n  border-radius: 0 0 2rem 2rem;\n  overflow: hidden;\n}\n\n[data-theme=\"minimal\"] .hero-section .hero-grid {\n  min-height: 480px !important;\n}\n@media (min-width: 1024px) {\n  [data-theme=\"minimal\"] .hero-section .hero-grid {\n    min-height: 560px !important;\n  }\n}\n\n/* Round the hero image container */\n[data-theme=\"minimal\"] .hero-section .hero-grid > div:last-child {\n  padding: 1.5rem 1.5rem 1.5rem 0;\n}\n[data-theme=\"minimal\"] .hero-section .hero-grid > div:last-child img {\n  border-radius: 1.5rem;\n}\n\n/* Accent line — pill shape */\n[data-theme=\"minimal\"] .hero-section .accent-line {\n  border-radius: 9999px;\n  height: 4px;\n  width: 3rem;\n}\n\n/* Hero label — badge pill */\n[data-theme=\"minimal\"] .hero-section .section-header-label {\n  background-color: rgba(255, 255, 255, 0.12);\n  display: inline-block;\n  padding: 0.375rem 1rem;\n  border-radius: 9999px;\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 1rem;\n}\n\n[data-theme=\"minimal\"] .hero-section .hero-text h1 {\n  text-transform: none;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n  font-weight: 700;\n}\n\n[data-theme=\"minimal\"] .hero-section .hero-text p {\n  color: rgba(255, 255, 255, 0.65);\n  font-family: \"Nunito\", ui-sans-serif, sans-serif;\n}\n\n/* Hero CTA — pill gradient button */\n[data-theme=\"minimal\"] .hero-section .hero-cta-primary {\n  background: linear-gradient(135deg, #f59e0b, #f97316) !important;\n  border: none;\n  border-radius: 9999px;\n  padding: 1rem 2.5rem;\n  font-weight: 700;\n  font-size: 0.9375rem;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.4);\n  transition: all 0.2s ease;\n}\n[data-theme=\"minimal\"] .hero-section .hero-cta-primary:hover {\n  box-shadow: 0 6px 24px rgba(249, 115, 22, 0.5);\n  transform: translateY(-1px);\n}\n\n/* Learn More — ghost pill, visible on gradient bg */\n[data-theme=\"minimal\"] .hero-section .hero-cta-secondary {\n  border-radius: 9999px;\n  border-width: 2px;\n  border-color: rgba(255, 255, 255, 0.3);\n  padding: 1rem 2.5rem;\n  font-weight: 600;\n  font-size: 0.9375rem;\n  text-transform: none;\n  letter-spacing: 0.02em;\n}\n[data-theme=\"minimal\"] .hero-section .hero-cta-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.6);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   SECTION HEADERS — centered, friendly, with decorative dot\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-header-label {\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: var(--color-accent);\n}\n\n[data-theme=\"minimal\"] .section-header-title {\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  font-size: 2rem;\n}\n@media (min-width: 640px) {\n  [data-theme=\"minimal\"] .section-header-title {\n    font-size: 2.5rem;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   FEATURED PRODUCTS — standard grid, soft bg\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-featured {\n  background-color: var(--color-surface-alt);\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n[data-theme=\"minimal\"] .section-featured .featured-grid {\n  gap: 1.5rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PROMO BADGES — rounded cards with colored icon bg, soft shadow\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .promo-badges {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n[data-theme=\"minimal\"] .promo-badges .promo-badge-card {\n  border-radius: var(--radius-theme);\n  border: none;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.05),\n    0 4px 12px rgba(0, 0, 0, 0.04);\n  transition: all 0.25s ease;\n}\n[data-theme=\"minimal\"] .promo-badges .promo-badge-card:hover {\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.08),\n    0 8px 24px rgba(0, 0, 0, 0.06);\n  transform: translateY(-2px);\n}\n\n/* Round the promo badge images */\n[data-theme=\"minimal\"] .promo-badges .promo-badge-card img {\n  border-radius: 10px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PROMO BANNER — rounded corners, gradient dark panel\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-promo-banner {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n[data-theme=\"minimal\"] .section-promo-banner > div > div {\n  border-radius: 1.5rem;\n  overflow: hidden;\n}\n\n[data-theme=\"minimal\"] .section-promo-banner .promo-dark-panel {\n  background: linear-gradient(135deg, #1e1b4b, #312e81);\n}\n\n[data-theme=\"minimal\"] .section-promo-banner .promo-dark-panel .accent-line {\n  border-radius: 9999px;\n  height: 4px;\n  background: linear-gradient(135deg, #f59e0b, #f97316);\n}\n\n[data-theme=\"minimal\"] .section-promo-banner .section-header-label {\n  color: #f59e0b;\n}\n\n[data-theme=\"minimal\"] .section-promo-banner .section-header-title {\n  color: white;\n  text-transform: none;\n  font-weight: 700;\n}\n\n[data-theme=\"minimal\"] .section-promo-banner a[href=\"/shop\"] {\n  border-radius: 9999px;\n  background: linear-gradient(135deg, #f59e0b, #f97316);\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   EXPLORE SECTION — light bg, rounded stat cards\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-explore {\n  background-color: #ffffff;\n}\n\n[data-theme=\"minimal\"] .section-explore .stat-value {\n  font-weight: 800;\n  color: var(--color-accent);\n  font-size: 3rem;\n}\n\n/* Round the category thumbnails */\n[data-theme=\"minimal\"] .section-explore .group.relative.overflow-hidden {\n  border-radius: var(--radius-theme);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PRODUCT GRID — standard 4-col, generous gaps, white bg\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-product-grid {\n  background-color: var(--color-surface-alt);\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n[data-theme=\"minimal\"] .section-product-grid .product-grid {\n  gap: 1.5rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PRODUCT CARD — rounded, shadowed, hover lift. Classic WP card.\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .product-card {\n  border-radius: var(--radius-theme);\n  overflow: hidden;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.06),\n    0 4px 12px rgba(0, 0, 0, 0.04);\n  border: none;\n  transition: all 0.25s ease;\n}\n[data-theme=\"minimal\"] .product-card:hover {\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.1),\n    0 16px 48px rgba(0, 0, 0, 0.06);\n  transform: translateY(-4px);\n}\n\n/* Quick-view bar — rounded, gradient */\n[data-theme=\"minimal\"] .product-card .quick-view-bar {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 600;\n  border-radius: 0;\n  padding: 0.75rem;\n}\n\n[data-theme=\"minimal\"] .product-card .product-name {\n  font-weight: 600;\n  font-size: 0.9375rem;\n  text-transform: none;\n}\n\n[data-theme=\"minimal\"] .product-card .product-price {\n  font-weight: 700;\n  color: var(--color-accent);\n  font-size: 0.9375rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   MEN'S SECTION — soft gradient bg instead of hard dark\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .section-mens {\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%) !important;\n  border-radius: 0;\n}\n\n[data-theme=\"minimal\"] .section-mens h2 {\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n[data-theme=\"minimal\"] .section-mens .section-header-label {\n  color: #f59e0b;\n}\n\n/* Men's section CTA — warm gradient pill */\n[data-theme=\"minimal\"] .section-mens a[href=\"/shop/men\"] {\n  border-radius: 9999px;\n  background: linear-gradient(135deg, #f59e0b, #f97316);\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   FOOTER — light gray bg, friendly, rounded top\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] footer {\n  background-color: var(--color-surface-alt) !important;\n  border-top: 1px solid var(--color-border-default);\n}\n\n[data-theme=\"minimal\"] footer .font-display {\n  color: var(--color-text-heading);\n}\n\n[data-theme=\"minimal\"] footer h3 {\n  color: var(--color-text-heading);\n  text-transform: none;\n  letter-spacing: 0.02em;\n  font-weight: 700;\n}\n\n[data-theme=\"minimal\"] footer a,\n[data-theme=\"minimal\"] footer li,\n[data-theme=\"minimal\"] footer p,\n[data-theme=\"minimal\"] footer span {\n  color: var(--color-text-primary);\n}\n\n[data-theme=\"minimal\"] footer a:hover {\n  color: var(--color-accent);\n}\n\n[data-theme=\"minimal\"] footer .border-t {\n  border-color: var(--color-border-default);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   SHOP PAGE — friendly, rounded\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .shop-header h1 {\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n[data-theme=\"minimal\"] .shop-header .accent-line {\n  border-radius: 9999px;\n  height: 4px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PDP — keep conversion layout, pill CTA\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"minimal\"] .pdp-add-to-cart {\n  border-radius: 9999px;\n  text-transform: none;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  font-size: 1rem;\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  border-color: transparent;\n  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);\n  transition: all 0.2s ease;\n}\n[data-theme=\"minimal\"] .pdp-add-to-cart:hover {\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);\n  transform: translateY(-1px);\n}\n\n/* ─── Theme: Vintage (Aesop-inspired) ─── */\n/* Quiet luxury. Warm parchment. Editorial serif. Sage olive accent.\n   Generous whitespace. Asymmetric grids. The product is the hero. */\n[data-theme=\"vintage\"] {\n  --font-display: \"Playfair Display\", \"Georgia\", serif;\n  --font-heading: \"Lora\", \"Georgia\", serif;\n  --font-editorial: \"Playfair Display\", \"Georgia\", serif;\n  --font-body: \"Lora\", \"Georgia\", serif;\n\n  /* Aesop palette — warm earth, sage, parchment */\n  --color-accent: #5c6b4f;\n  --color-accent-hover: #4a5840;\n  --color-accent-light: #f0f2ec;\n  --color-surface: #faf6f1;\n  --color-surface-alt: #f0ebe3;\n  --color-surface-inverse: #2c1810;\n  --color-text-primary: #4a3728;\n  --color-text-heading: #2c1810;\n  --color-text-secondary: #8c7b6b;\n  --color-text-inverse: #faf6f1;\n  --color-border-default: #ddd5c9;\n  --color-border-strong: #2c1810;\n  --color-btn-primary-bg: #2c1810;\n  --color-btn-primary-text: #faf6f1;\n  --color-btn-primary-border: #2c1810;\n  --color-btn-primary-hover-bg: #5c6b4f;\n  --color-btn-primary-hover-border: #5c6b4f;\n\n  --radius-theme: 0px;\n  --radius-theme-lg: 0px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   VINTAGE THEME — \"Aesop Storefront\"\n   Quiet luxury, catalog-dense, 1px hairlines, monochromatic warmth.\n   Dramatically different spatial rhythm from streetwear.\n   ═══════════════════════════════════════════════════════════ */\n\n/* ─── Component base overrides ─── */\n\n[data-theme=\"vintage\"] .jp-btn-primary,\n[data-theme=\"vintage\"] .jp-btn-secondary,\n[data-theme=\"vintage\"] .jp-btn-ghost {\n  text-transform: none;\n  letter-spacing: 0.02em;\n  font-weight: 400;\n  border-width: 1px;\n  padding: 0.875rem 2rem;\n  font-size: 0.8125rem;\n}\n\n[data-theme=\"vintage\"] .jp-card {\n  box-shadow: none;\n  border-color: var(--color-border-default);\n}\n[data-theme=\"vintage\"] .jp-card:hover {\n  box-shadow: none;\n  border-color: var(--color-accent);\n}\n\n[data-theme=\"vintage\"] .jp-input,\n[data-theme=\"vintage\"] .jp-select {\n  border-width: 1px;\n  padding: 0.75rem 1rem;\n}\n\n[data-theme=\"vintage\"] .jp-label {\n  text-transform: none;\n  letter-spacing: 0.03em;\n  font-weight: 600;\n  font-size: 0.75rem;\n}\n\n/* ─── Section reordering via flexbox on main ─── */\n[data-theme=\"vintage\"] main {\n  display: flex;\n  flex-direction: column;\n}\n[data-theme=\"vintage\"] .hero-section {\n  order: 1;\n}\n[data-theme=\"vintage\"] .section-featured {\n  order: 2;\n}\n[data-theme=\"vintage\"] .section-explore {\n  order: 3;\n}\n[data-theme=\"vintage\"] .section-product-grid {\n  order: 4;\n}\n[data-theme=\"vintage\"] .section-promo-banner {\n  order: 5;\n}\n[data-theme=\"vintage\"] .section-mens {\n  order: 6;\n}\n[data-theme=\"vintage\"] .promo-badges {\n  order: 7;\n  display: none;\n}\n\n/* ─── Navbar — minimal hairline, no heavy border ─── */\n[data-theme=\"vintage\"] .site-nav {\n  border-bottom-width: 1px;\n  border-bottom-color: var(--color-border-default);\n}\n\n/* ─── Announcement bar — calm, understated ─── */\n[data-theme=\"vintage\"] .announcement-bar {\n  text-transform: none;\n  letter-spacing: 0.08em;\n  font-weight: 400;\n  font-size: 0.6875rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HERO — Anti-hero. Collapsed, text-only, no image.\n   Short parchment banner with centered editorial headline.\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .hero-section {\n  background-color: var(--color-surface) !important;\n  border-bottom: 1px solid var(--color-border-default);\n}\n\n[data-theme=\"vintage\"] .hero-section .hero-grid {\n  grid-template-columns: 1fr !important;\n  min-height: auto !important;\n  text-align: center;\n}\n\n/* Hide the hero image entirely */\n[data-theme=\"vintage\"] .hero-section .hero-grid > div:last-child {\n  display: none;\n}\n\n/* Center the text block, generous vertical padding */\n[data-theme=\"vintage\"] .hero-section .hero-text {\n  order: 1;\n  align-items: center;\n  text-align: center;\n  padding: 5rem 2rem 4rem;\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n/* Hide the accent line in hero — too streetwear */\n[data-theme=\"vintage\"] .hero-section .accent-line {\n  display: none;\n}\n\n/* Hide the \"New Collection\" label — too promotional */\n[data-theme=\"vintage\"] .hero-section .section-header-label {\n  display: none;\n}\n\n[data-theme=\"vintage\"] .hero-section .hero-text h1 {\n  color: var(--color-text-heading);\n  text-transform: none;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n  line-height: 1.05;\n  font-style: italic;\n  font-size: 3rem;\n}\n@media (min-width: 640px) {\n  [data-theme=\"vintage\"] .hero-section .hero-text h1 {\n    font-size: 3.75rem;\n  }\n}\n\n[data-theme=\"vintage\"] .hero-section .hero-text p {\n  color: var(--color-text-secondary);\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Hero CTAs — single understated button style */\n[data-theme=\"vintage\"] .hero-section .hero-cta-primary {\n  background-color: var(--color-btn-primary-bg);\n  color: var(--color-btn-primary-text);\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 400;\n  font-size: 0.8125rem;\n  border: 1px solid var(--color-btn-primary-border);\n  padding: 0.875rem 2.5rem;\n}\n[data-theme=\"vintage\"] .hero-section .hero-cta-primary:hover {\n  background-color: var(--color-btn-primary-hover-bg);\n  border-color: var(--color-btn-primary-hover-border);\n}\n\n/* FIXED: Learn More button — dark text + dark border on light bg */\n[data-theme=\"vintage\"] .hero-section .hero-cta-secondary {\n  color: var(--color-text-heading);\n  border-color: var(--color-border-default);\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 400;\n  font-size: 0.8125rem;\n  border-width: 1px;\n}\n[data-theme=\"vintage\"] .hero-section .hero-cta-secondary:hover {\n  border-color: var(--color-text-heading);\n  color: var(--color-text-heading);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   SECTION HEADERS — editorial italic, understated\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-header-label {\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-style: italic;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  font-weight: 400;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"vintage\"] .section-header-title {\n  text-transform: none;\n  font-weight: 400;\n  letter-spacing: -0.01em;\n  font-style: italic;\n  color: var(--color-text-heading);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   FEATURED PRODUCTS — first section after hero.\n   Full-width parchment bg, 1px divider above.\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-featured {\n  background-color: var(--color-surface);\n  border-top: 1px solid var(--color-border-default);\n  border-bottom: 1px solid var(--color-border-default);\n  padding-top: 3.5rem;\n  padding-bottom: 3.5rem;\n}\n\n[data-theme=\"vintage\"] .section-featured .featured-grid {\n  gap: 0;\n}\n@media (min-width: 1024px) {\n  [data-theme=\"vintage\"] .section-featured .featured-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0;\n  }\n}\n\n/* Hairline borders between featured cards */\n[data-theme=\"vintage\"] .section-featured .featured-grid > * {\n  border-right: 1px solid var(--color-border-default);\n  padding: 0 0.75rem;\n}\n[data-theme=\"vintage\"] .section-featured .featured-grid > *:last-child {\n  border-right: none;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   EXPLORE SECTION — thin horizontal stats strip\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-explore {\n  background-color: var(--color-surface-alt);\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n  border-top: 1px solid var(--color-border-default);\n  border-bottom: 1px solid var(--color-border-default);\n}\n\n/* Hide the section header in explore — just show the stats */\n[data-theme=\"vintage\"] .section-explore .text-center.mb-14 {\n  display: none;\n}\n\n/* Stats row — tighter, horizontal strip */\n[data-theme=\"vintage\"] .section-explore .stat-value {\n  font-weight: 400;\n  font-style: italic;\n  font-size: 2.25rem;\n}\n\n/* Hide category thumbnails — too visual for Aesop catalog feel */\n[data-theme=\"vintage\"] .section-explore .grid.grid-cols-2.sm\\:grid-cols-4.gap-3 {\n  display: none;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PRODUCT GRID — tight 4-col catalog with hairline borders\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-product-grid {\n  background-color: var(--color-surface);\n  padding-top: 3.5rem;\n  padding-bottom: 3.5rem;\n}\n\n@media (min-width: 1024px) {\n  [data-theme=\"vintage\"] .section-product-grid .product-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0;\n  }\n}\n@media (max-width: 1023px) {\n  [data-theme=\"vintage\"] .section-product-grid .product-grid {\n    gap: 0;\n  }\n}\n\n/* Hairline borders between product grid cards */\n[data-theme=\"vintage\"] .section-product-grid .product-grid > * {\n  border-right: 1px solid var(--color-border-default);\n  border-bottom: 1px solid var(--color-border-default);\n  padding: 0.5rem;\n}\n[data-theme=\"vintage\"] .section-product-grid .product-grid > *:nth-child(4n) {\n  border-right: none;\n}\n@media (max-width: 1023px) and (min-width: 640px) {\n  [data-theme=\"vintage\"] .section-product-grid .product-grid > *:nth-child(3n) {\n    border-right: none;\n  }\n}\n@media (max-width: 639px) {\n  [data-theme=\"vintage\"] .section-product-grid .product-grid > *:nth-child(2n) {\n    border-right: none;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PRODUCT CARD — catalog style. No hover scale, no quick-view.\n   Border-bottom accent on hover. Minimal.\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .product-card {\n  background-color: var(--color-surface);\n  transition: border-color 0.3s ease;\n}\n[data-theme=\"vintage\"] .product-card:hover {\n  border-bottom: 2px solid var(--color-accent);\n}\n\n/* Kill the zoom-on-hover effect */\n[data-theme=\"vintage\"] .product-card img {\n  transition: none !important;\n  transform: none !important;\n}\n[data-theme=\"vintage\"] .product-card:hover img {\n  transform: none !important;\n}\n\n/* Hide the hover darkening overlay */\n[data-theme=\"vintage\"] .product-card .absolute.inset-0 {\n  display: none;\n}\n\n/* Hide quick-view bar entirely */\n[data-theme=\"vintage\"] .product-card .quick-view-bar {\n  display: none;\n}\n\n[data-theme=\"vintage\"] .product-card .product-name {\n  font-family: \"Playfair Display\", \"Georgia\", serif;\n  font-weight: 400;\n  font-style: italic;\n  font-size: 0.9375rem;\n  color: var(--color-text-heading);\n}\n\n[data-theme=\"vintage\"] .product-card .product-price {\n  font-family: \"Lora\", \"Georgia\", serif;\n  color: var(--color-text-secondary);\n  font-size: 0.8125rem;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PROMO BANNER — full-width warm bg, text overlaid on image\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-promo-banner {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n[data-theme=\"vintage\"] .section-promo-banner .promo-dark-panel {\n  background-color: var(--color-surface-inverse);\n}\n\n[data-theme=\"vintage\"] .section-promo-banner .promo-dark-panel .accent-line {\n  background-color: var(--color-accent);\n}\n\n[data-theme=\"vintage\"] .section-promo-banner .section-header-label {\n  color: var(--color-accent);\n}\n\n[data-theme=\"vintage\"] .section-promo-banner .section-header-title {\n  color: var(--color-text-inverse);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   MEN'S SECTION — warm bg instead of dark inverse,\n   text-heavy layout, calm and editorial\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .section-mens {\n  background-color: var(--color-surface-alt) !important;\n  border-top: 1px solid var(--color-border-default);\n}\n\n[data-theme=\"vintage\"] .section-mens h2 {\n  color: var(--color-text-heading);\n  text-transform: none;\n  font-style: italic;\n}\n\n[data-theme=\"vintage\"] .section-mens .section-header-label {\n  color: var(--color-accent);\n}\n\n[data-theme=\"vintage\"] .section-mens p {\n  color: var(--color-text-secondary);\n}\n\n/* Men's section CTA — dark bg button on warm surface */\n[data-theme=\"vintage\"] .section-mens a[href=\"/shop/men\"] {\n  background-color: var(--color-btn-primary-bg);\n  color: var(--color-btn-primary-text);\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 400;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   FOOTER — warm parchment instead of dark\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] footer {\n  background-color: var(--color-surface-alt) !important;\n  border-top: 1px solid var(--color-border-default);\n}\n\n[data-theme=\"vintage\"] footer h3 {\n  color: var(--color-text-secondary);\n  text-transform: none;\n  letter-spacing: 0.06em;\n}\n\n[data-theme=\"vintage\"] footer a,\n[data-theme=\"vintage\"] footer li,\n[data-theme=\"vintage\"] footer p,\n[data-theme=\"vintage\"] footer span {\n  color: var(--color-text-secondary);\n}\n\n[data-theme=\"vintage\"] footer a:hover {\n  color: var(--color-text-heading);\n}\n\n[data-theme=\"vintage\"] footer .font-display {\n  color: var(--color-text-heading);\n}\n\n[data-theme=\"vintage\"] footer .border-t {\n  border-color: var(--color-border-default);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   SHOP PAGE\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .shop-header h1 {\n  text-transform: none;\n  font-style: italic;\n  font-weight: 400;\n}\n\n[data-theme=\"vintage\"] .shop-header .accent-line {\n  background-color: var(--color-accent);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PDP — keep conversion layout, refine styling\n   ═══════════════════════════════════════════════════════════ */\n\n[data-theme=\"vintage\"] .pdp-add-to-cart {\n  text-transform: none;\n  letter-spacing: 0.04em;\n  font-weight: 400;\n}\n\n/* Base styles */\n@layer base {\n  body {\n    @apply antialiased;\n    background-color: var(--color-surface);\n    color: var(--color-text-primary);\n    font-feature-settings:\n      \"kern\" 1,\n      \"liga\" 1;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    @apply font-heading tracking-tight;\n    color: var(--color-text-heading);\n  }\n}\n\n/* Component styles */\n@layer components {\n  /* Card */\n  .jp-card {\n    background-color: var(--color-surface);\n    border: 1px solid var(--color-border-default);\n    border-radius: var(--radius-theme);\n    @apply shadow-sm transition-shadow duration-200;\n  }\n\n  .jp-card:hover {\n    @apply shadow-lg;\n  }\n\n  /* Primary button — uses semantic tokens for theme switching */\n  .jp-btn-primary {\n    @apply inline-flex items-center justify-center px-6 py-3;\n    @apply font-heading font-semibold text-sm uppercase tracking-wider;\n    @apply focus:outline-none focus:ring-2 focus:ring-offset-2;\n    @apply transition-all duration-200;\n    background-color: var(--color-btn-primary-bg);\n    color: var(--color-btn-primary-text);\n    border: 2px solid var(--color-btn-primary-border);\n    border-radius: var(--radius-theme);\n    --tw-ring-color: var(--color-accent);\n  }\n  .jp-btn-primary:hover {\n    background-color: var(--color-btn-primary-hover-bg);\n    border-color: var(--color-btn-primary-hover-border);\n  }\n\n  /* Secondary button */\n  .jp-btn-secondary {\n    @apply inline-flex items-center justify-center px-6 py-3;\n    @apply font-heading font-semibold text-sm uppercase tracking-wider;\n    @apply focus:outline-none focus:ring-2 focus:ring-offset-2;\n    @apply transition-all duration-200;\n    background-color: var(--color-surface);\n    color: var(--color-text-heading);\n    border: 2px solid var(--color-border-strong);\n    border-radius: var(--radius-theme);\n    --tw-ring-color: var(--color-accent);\n  }\n  .jp-btn-secondary:hover {\n    background-color: var(--color-surface-inverse);\n    color: var(--color-text-inverse);\n  }\n\n  /* Ghost button */\n  .jp-btn-ghost {\n    @apply inline-flex items-center justify-center px-4 py-2.5;\n    @apply font-heading font-semibold text-sm uppercase tracking-wider;\n    @apply focus:outline-none focus:ring-2 focus:ring-offset-2;\n    @apply transition-all duration-200;\n    background-color: transparent;\n    color: var(--color-text-secondary);\n    border: 2px solid transparent;\n    border-radius: var(--radius-theme);\n    --tw-ring-color: var(--color-accent);\n  }\n  .jp-btn-ghost:hover {\n    color: var(--color-text-heading);\n    border-color: var(--color-border-strong);\n  }\n\n  /* Danger button */\n  .jp-btn-danger {\n    @apply inline-flex items-center justify-center px-6 py-3;\n    @apply bg-white text-shu-600 font-heading font-semibold text-sm uppercase tracking-wider;\n    @apply border-2 border-shu-500;\n    @apply hover:bg-shu-600 hover:text-white hover:border-shu-600 focus:outline-none focus:ring-2 focus:ring-shu-500 focus:ring-offset-2;\n    @apply transition-all duration-200;\n    border-radius: var(--radius-theme);\n  }\n\n  /* Success button */\n  .jp-btn-success {\n    @apply inline-flex items-center justify-center px-6 py-3;\n    @apply bg-matcha-600 text-white font-heading font-semibold text-sm uppercase tracking-wider;\n    @apply border-2 border-transparent;\n    @apply hover:bg-matcha-700 focus:outline-none focus:ring-2 focus:ring-matcha-500 focus:ring-offset-2;\n    @apply transition-all duration-200;\n    border-radius: var(--radius-theme);\n  }\n\n  /* Status badges */\n  .jp-badge {\n    @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider;\n    @apply border;\n  }\n\n  .jp-badge-active {\n    @apply bg-matcha-50 text-matcha-700 border-matcha-200;\n  }\n\n  .jp-badge-sold {\n    @apply bg-indigo-jp-50 text-indigo-jp-700 border-indigo-jp-200;\n  }\n\n  .jp-badge-archived {\n    @apply bg-sumi-100 text-sumi-600 border-sumi-200;\n  }\n\n  /* Form inputs */\n  .jp-input {\n    @apply block w-full px-3 py-2.5 text-sm;\n    @apply focus:outline-none;\n    @apply transition-colors duration-150;\n    color: var(--color-text-primary);\n    background-color: var(--color-surface);\n    border: 2px solid var(--color-border-default);\n    border-radius: var(--radius-theme);\n  }\n  .jp-input::placeholder {\n    color: var(--color-text-secondary);\n  }\n  .jp-input:focus {\n    border-color: var(--color-border-strong);\n  }\n\n  .jp-select {\n    @apply block w-full px-3 py-2.5 text-sm;\n    @apply focus:outline-none;\n    @apply transition-colors duration-150;\n    color: var(--color-text-primary);\n    background-color: var(--color-surface);\n    border: 2px solid var(--color-border-default);\n    border-radius: var(--radius-theme);\n  }\n  .jp-select:focus {\n    border-color: var(--color-border-strong);\n  }\n\n  .jp-label {\n    @apply block text-xs font-heading font-semibold uppercase tracking-wider mb-2;\n    color: var(--color-text-heading);\n  }\n\n  /* Section divider */\n  .jp-divider {\n    border-top: 1px solid var(--color-border-default);\n  }\n\n  /* Link styles */\n  .jp-link {\n    @apply underline underline-offset-2;\n    @apply transition-colors duration-150;\n    color: var(--color-text-heading);\n  }\n  .jp-link:hover {\n    color: var(--color-accent);\n  }\n}\n\n/* Rich text editor (TipTap / ProseMirror) */\n.rte-content .tiptap {\n  outline: none;\n  min-height: 120px;\n}\n.rte-content .tiptap h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0.5em 0;\n}\n.rte-content .tiptap h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0.5em 0;\n}\n.rte-content .tiptap ul {\n  list-style: disc;\n  padding-left: 1.5em;\n}\n.rte-content .tiptap ol {\n  list-style: decimal;\n  padding-left: 1.5em;\n}\n.rte-content .tiptap a {\n  color: var(--color-sumi-900);\n  text-decoration: underline;\n}\n.rte-content .tiptap p {\n  margin: 0.25em 0;\n}\n.rte-content .tiptap blockquote {\n  border-left: 3px solid var(--color-sumi-300);\n  padding-left: 1em;\n  color: var(--color-sumi-500);\n  margin: 0.5em 0;\n}\n\n/* Rich content rendered on storefront (product descriptions, etc.) */\n.rich-content h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0.75em 0 0.25em;\n}\n.rich-content h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0.75em 0 0.25em;\n}\n.rich-content ul {\n  list-style: disc;\n  padding-left: 1.5em;\n  margin: 0.5em 0;\n}\n.rich-content ol {\n  list-style: decimal;\n  padding-left: 1.5em;\n  margin: 0.5em 0;\n}\n.rich-content a {\n  color: var(--color-sumi-900);\n  text-decoration: underline;\n}\n.rich-content p {\n  margin: 0.25em 0;\n}\n.rich-content blockquote {\n  border-left: 3px solid var(--color-sumi-300);\n  padding-left: 1em;\n  color: var(--color-sumi-500);\n  margin: 0.5em 0;\n}\n\n/* Noise texture overlay for sections that want it */\n.noise-texture::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  opacity: 0.03;\n  pointer-events: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n  background-size: 128px 128px;\n}\n\n/* Utility classes */\n@layer utilities {\n  .shadow-jp {\n    box-shadow:\n      0 1px 3px 0 rgba(26, 26, 23, 0.08),\n      0 1px 2px 0 rgba(26, 26, 23, 0.06);\n  }\n\n  .shadow-jp-md {\n    box-shadow:\n      0 4px 12px -2px rgba(26, 26, 23, 0.1),\n      0 2px 4px -1px rgba(26, 26, 23, 0.06);\n  }\n\n  /* Display font utility — inherits from theme */\n  .font-display-xl {\n    font-family: var(--font-display);\n    letter-spacing: 0.02em;\n    line-height: 0.9;\n  }\n}\n\n@keyframes cart-throb {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(1.6);\n  }\n  50% {\n    transform: scale(0.9);\n  }\n  75% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.animate-cart-throb {\n  animation: cart-throb 1s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
